import React, { useEffect, useState } from "react";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  Box,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  Grid,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Paper,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import AppInput from "components/Input/AppInput";
import AppButton from "components/CustomButtons/AppButton";
import AppSelect from "components/Select/AppSelect";
import AppColor from "utilities/AppColor";
import { YupValidations } from "utils/validate";
import InputAutocompleteAddress from "components/Input/InputAutocompleteAddress";
import CustomDatePicker from "components/Input/CustomDatePicker";
import { useParams } from "react-router";
import moment from "moment-timezone";
import AppRadio from "components/Input/AppRadio";
import SelectField from "components/Select/SelectField";
import { fetchSupports, getSupports } from "store/slices/worker";
import {
  getWorkerApplied,
  getJobDetail,
  jobRemoveWorker,
  reduceCreateJob,
  // reduceUpdateJob,
  fetchJobDetail,
} from "store/slices/job";
import { autoBooking, fetchPageBookingByJob } from "store/slices/booking";
import { getAuthInfo } from "store/slices/auth";

import { useDispatch, useSelector } from "react-redux";
import { BILLING_TYPE, MASK, JOB_TYPE } from "config/AppConfig";
import AppDialog from "components/Dialog/AppDialog";

// import WorkerCalendarModal from "./WorkerCalendarModal";
import { useHistory } from "react-router-dom";
import { POST_JOB } from "config/AppConfig";
import { BOOKING_STATUS } from "config/AppConfig";
// import { Label } from "reactstrap";
// import SelectTime from "components/Select/SelectTime";
import classNames from "classnames";
import { fetchClientList } from "store/slices/client";
import BookingWorkerModal from "views/Client/Job/Components/BookingWorkerModal";
import JobUserTag from "views/Client/Job/Components/JobUserTag";
import SearchWorkerModal from "views/Client/Job/Components/SearchWorkerModal";
import AppUtil from "utilities/AppUtil";
import { JOB_STATUS } from "config/AppConfig";
import { showToast } from "store/slices/toast";
// import { LIMIT_MINUTES_CREATE_JOB } from "config/AppConfig";
// import { getAllCanceledBooking } from "store/slices/job";
import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import ChatContents from "views/Client/Job/Components/ChatContents";
// import TableBookingWillCancel from "./component/TableBookingWillCancel";
import { SHIFT_COLOR } from "config/AppConfig";
import { reduceDeleteJob } from "store/slices/job";
import { reduceEndJob } from "store/slices/job";
import JobAvailabilityFieldArray from "./component/JobAvailabilityFieldArray";
import { updateInformationJob } from "store/slices/job";
import { addNewShiftSetting } from "store/slices/job";
import { updateShiftSetting } from "store/slices/job";
import { deleteShiftSetting } from "store/slices/job";
// import { getAllCanceledBooking } from "store/slices/job";
import { updateShiftSegment } from "store/slices/job";
import { addOrDeleteShiftSetting } from "store/slices/job";
import { ChevronRight } from "@material-ui/icons";
// import CalendarIcon from "assets/icons/calendar-color.svg";
// import WorkerCalendarModal from "views/Client/Job/Components/WorkerCalendarModal";

const defaultWorkHistory = {
  // dayOfWeek: DAYS_OF_WEEK[0],
  isNew: true,
  shiftType: "",
  startTime: moment(new Date()).hours(0).minutes(0).format("YYYY/MM/DD HH:mm"),
  endTime: moment(new Date()).hours(0).minutes(0).format("YYYY/MM/DD HH:mm"),
  numberWorkers: "",
  numberDayOfWeek: 0,
  isExpand: true,
  groupByDayOfWeek: {},
  segments: [],
};
const COUNT_WEEK_DAY = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};
const enumConfirmDialog = {
  deleteShift: 1,
  deleteDayOfWeek: 2,
  deleteShiftHasBooked: 3,
  deleteDayOfWeekHasBooked: 4,
  deleteDayOfWeekListHasBooked: 5,
  changeSettingBooking: 6,
  // 'deleteAndChangeSettingBooking': 7, // case 5 + 6
};
// const maskNumber = "999999999999999";

const JobDetail = () => {
  const isMobile = AppUtil.mobileAndTabletCheck();
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { id: jobId } = useParams();

  const authInfo = useSelector(getAuthInfo) || {};
  const supports = useSelector(getSupports) || [];
  const jobDetail = useSelector(getJobDetail) || {};
  const { companyId } = authInfo;

  const [latLng, setLatLng] = useState();
  const [minEndDate, setMinEndDate] = useState();
  const [clientIds, setClientIds] = useState([]);
  const [isBooked, setIsBooked] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState({});
  const [workersApplied, setWorkersApplied] = useState([]);
  const [jobAvailabilityList, setJobAvailabilityList] = useState([]);
  // const [bookingCanceledList, setBookingCanceledList] = useState([]);
  // const [jobAvailabilityDelete, setJobAvailabilityDelete] = useState(null);

  const [showConfirmDeleteNextWeek, setShowConfirmDeleteNextWeek] = useState(
    false
  );
  const [dataUpdateShift, setDataUpdateShift] = useState(null);
  // const [showBookingCanceledList, setShowBookingCanceledList] = useState(false);
  const [
    showModalSelectCurrentOrNextWeek,
    setShowModalSelectCurrentOrNextWeek,
  ] = useState(false);
  const [
    showConfirmSelectedNextOrCurrent,
    setShowConfirmSelectedNextOrCurrent,
  ] = useState(false);
  const [isSelectedNextWeek, setIsSelectedNextWeek] = useState(false);
  const [showBookingWorker, setShowBookingWorker] = useState(false);
  const [showSearchWorker, setShowSearchWorker] = useState(false);
  const [showDeleteOrEndJobModal, setShowDeleteOrEndJobModal] = useState(null);
  const [
    messageDeleteAvailabilityModal,
    setMessageDeleteAvailabilityModal,
  ] = useState(null);
  const [idsDeleteAvailability, setIdsDeleteAvailability] = useState([]);
  const [paramsDeleteDayOfWeek, setParamsDeleteDayOfWeek] = useState(null);
  // const [showCalendar, setShowCalendar] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [jobType, setJobType] = useState(false);
  const [reload, setReload] = useState(false);
  const [isOpenModalAutoBooking, setIsOpenModalAutoBooking] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isShowChat, setIsShowChat] = useState(false);

  // Chat panel state
  const [chatFilterWorkerId, setChatFilterWorkerId] = useState("ALL");
  const [chatFilterShiftType, setChatFilterShiftType] = useState("ALL");
  const [chatSelectedBookingId, setChatSelectedBookingId] = useState(null);
  const [chatBookings, setChatBookings] = useState([]);
  const [chatBookingsPage, setChatBookingsPage] = useState(1);
  const [chatBookingsTotalPages, setChatBookingsTotalPages] = useState(0);
  const [chatBookingsLoading, setChatBookingsLoading] = useState(false);
  const [chatBookingsFiltering, setChatBookingsFiltering] = useState(false);

  const [initializeData, setInitializeData] = useState({
    clientId: "",
    title: "",
    description: "",
    address1: "",
    address2: "",
    postalCode: "",
    department: "",
    floor: "",
    accreditationId: "",
    specialtyId: "",
    supportId: "",
    coordParticipantId: "",
    yearsOfExperience: "",
    startDate: "",
    endDate: "",
    jobAvailabilityRequests: [defaultWorkHistory],
    isPostJob: POST_JOB.POST_JOB,
    phone: "",
    status: '',

    planManagerEmail: "",
    planManagerOrganizationName: "",
    planManagerPhone: "",
    billToAddress: "",
    billingDetail: "",
  });

  const isAdd = !jobId;
  const { lat, lng } = latLng || {};

  const useStyles = makeStyles((theme) => ({
    textarea: {
      height: "100px !important",
    },
    control: {
      display: "flex",
      flexWrap: isMobile ? "nowrap" : "wrap",
      flexDirection: "row",
      justifyContent: "flex-end",
      marginTop: "1rem",
    },
    radio: {
      color: AppColor.black,
      "& .MuiFormControlLabel-label": {
        fontSize: "1rem",
        fontWeight: 700,
      },
    },
    radioGroup: {
      flexDirection: "row",
    },
    postDescription: {
      border: "1px solid rgba(0, 0, 0, 0.2)",
      padding: "0.5rem 1rem",
      color: AppColor.black,
    },
    bold: {
      fontWeight: 700,
    },
    wrapShift: {
      border: "1px solid #c4b5bc",
      padding: "1rem",
      boxShadow: "0px 4px 4px rgb(0 0 0 / 25%)",
      borderRadius: 4,
      marginBottom: "0.5rem",
      "& .shiftInfo": {
        margin: "-1rem -1rem 1rem -1rem",
        padding: "0.3rem 1rem",
        border: "1px solid #c4b5bc",
        borderRadius: 4,
        backgroundColor: AppColor.white,
        display: "flex",
        justifyContent: "space-between",
      },
      "& .shiftInfo.MORNING": {
        backgroundColor: SHIFT_COLOR.MORNING,
        color: "#fff",
      },
      "& .shiftInfo.AFTERNOON": {
        backgroundColor: SHIFT_COLOR.AFTERNOON,
        color: "#fff",
      },
      "& .shiftInfo.EVENING": {
        backgroundColor: SHIFT_COLOR.EVENING,
        color: "#fff",
      },
      "& .shiftInfo.NIGHT": {
        backgroundColor: SHIFT_COLOR.NIGHT,
        color: "#fff",
      },
    },
    collapseShift: {
      border: "none",
      boxShadow: "none",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      padding: "0 1rem",
      margin: "0.5rem 0",
      "& .shiftInfo": {
        margin: 0,
        padding: "0.3rem 1rem",
        border: "1px solid #c4b5bc",
        borderRadius: 4,
        flex: "1 0 100%",
        backgroundColor: AppColor.white,
        display: "flex",
        justifyContent: "space-between",
      },
      "& .shiftInfo.MORNING": {
        backgroundColor: SHIFT_COLOR.MORNING,
        color: "#fff",
      },
      "& .shiftInfo.AFTERNOON": {
        backgroundColor: SHIFT_COLOR.AFTERNOON,
        color: "#fff",
      },
      "& .shiftInfo.EVENING": {
        backgroundColor: SHIFT_COLOR.EVENING,
        color: "#fff",
      },
      "& .shiftInfo.NIGHT": {
        backgroundColor: SHIFT_COLOR.NIGHT,
        color: "#fff",
      },
      "& .remove-icon": {
        fontSize: "2rem",
        color: AppColor.red,
      },
    },
    title: {
      display: "flex",
      // margin: "2rem 0 1rem 0",
      "& h5": {
        color: AppColor.black,
      },
    },
    calendar: {
      cursor: "pointer",
    },
    label: {
      fontSize: 14,
      color: AppColor.black,
      fontWeight: "500",
    },
    timePicker: {
      display: "flex",
      "& .form-group": {
        flex: "1 0 0px",
      },
    },
    deleteRight: {
      cursor: "pointer",
    },
    disabled: {
      opacity: 0.6,
      pointerEvents: "none",
    },
    noteContent: {
      boxSizing: "border-box",
      border: "1px solid rgba(0, 0, 0, 0.1)",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      backgroundColor: "#FFFFFF",
    },
    processNote: {
      width: "100%",
      height: "auto",
      border: "1px #000000 10%",
      padding: "20px",
    },
    icons: {
      cursor: "pointer",
      height: "49px",
      width: "49px",
      background: "#FFFFFF",
      border: "0.5px solid #000000",
      borderRadius: "24px",
    },
    listNote: {
      width: "100%",
      height: "auto",
      border: "1px #000000 10%",
      padding: "20px",
    },
    horizontalBar: {
      marginTop: "1rem",
      marginBottom: "1rem",
      border: "1px solid #cacaca",
      textAlign: "center",
      width: "95%",
      borderTop: "0",
    },
    customUserName: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "17px",
      color: "#C78D3C",
    },
    customDayNote: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "17px",
      color: "#000000",
    },
    textField: {
      width: "100%",
      "& .MuiInputBase-input": {
        height: "200px",
        verticalAlign: "top",
      },
    },
    paper: {
      marginRight: theme.spacing(2),
    },
    listItem: {
      marginBottom: "20px",
      padding: "10px",
      border: "1px solid rgba(0, 0, 0, 0.2)",
      borderRadius: "5px",
      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      "&:hover": {
        backgroundColor: AppColor.mainColor,
        color: AppColor.white,
      },
    },
    listTitle: {
      fontSize: "16px",
      color: AppColor.black,
      fontWeight: "500",
      padding: 0,
      margin: 0,
    },
  }));

  const classes = useStyles();

  const billingDetailsOptions = [
    {
      value: BILLING_TYPE.PLAN_MANAGER.id,
      label: t(BILLING_TYPE.PLAN_MANAGER.label),
    },
    {
      value: BILLING_TYPE.NDIA.id,
      label: t(BILLING_TYPE.NDIA.label),
    },
    {
      value: BILLING_TYPE.SELF.id,
      label: t(BILLING_TYPE.SELF.label),
    },
  ];
  const supportOptions = supports.map((item) => {
    return {
      value: item.id,
      label: item.name,
    };
  });

  const isValidShift = (availability) => {
    const {
      numberWorkers,
      shiftType,
      startTime,
      endTime,
      groupByDayOfWeek,
      segments,
    } = availability;
    if (!numberWorkers || !shiftType || !startTime || !endTime || !segments) {
      return false;
    }
    if (
      Number(numberWorkers) < 1 ||
      shiftType === "" ||
      startTime === "" ||
      endTime === ""
    ) {
      return false;
    }
    if (Object.keys(groupByDayOfWeek).length === 0) {
      return false;
    }
    if (moment.range(moment(startTime), moment(endTime)).diff("minutes") <= 0) {
      return false;
    }
    for (let i = 0; i < segments.length; i++) {
      if (segments[i].status === "ACTIVE") {
        if (
          !segments[i].shiftType ||
          segments[i].shiftType === "" ||
          !segments[i].startTime ||
          segments[i].startTime === "" ||
          !segments[i].endTime ||
          segments[i].endTime === ""
        ) {
          return false;
        }
        if (
          moment
            .range(moment(segments[i].startTime), moment(segments[i].endTime))
            .diff("minutes") <= 0
        ) {
          return false;
        }
        // check segment with min max time
        if (
          moment
            .range(moment(startTime), moment(segments[i].startTime))
            .diff("minutes") < 0 ||
          moment
            .range(moment(endTime), moment(segments[i].endTime))
            .diff("minutes") > 0
        ) {
          return false;
        }
        if (i + 1 < segments.length) {
          for (let j = i + 1; j < segments.length; j++) {
            if (segments[j].status === "ACTIVE") {
              if (
                !segments[j].shiftType ||
                segments[j].shiftType === "" ||
                !segments[j].startTime ||
                segments[j].startTime === "" ||
                !segments[j].endTime ||
                segments[j].endTime === ""
              ) {
                return false;
              }
              // check conflict time
              if (
                AppUtil.isConflictTime(
                  {
                    startTime: moment(segments[i].startTime),
                    endTime: moment(segments[i].endTime),
                  },
                  {
                    startTime: moment(segments[j].startTime),
                    endTime: moment(segments[j].endTime),
                  }
                )
              ) {
                return false;
              }
              // check duplicates shift type
              // if (segments[i].shiftType === segments[j].shiftType ) {
              //   return false;
              // }
            }
          }
        }
      }
    }
    return true;
  };

  const isValidJobInfo = (formData) => {
    const {
      clientId,
      title,
      description,
      address1,
      address2,
      phone,
      postalCode,
      supportId,
      yearsOfExperience,
      startDate,
      endDate,
      department,
      floor,
    } = formData;
    if (
      !title ||
      !clientId ||
      !description ||
      !address1 ||
      !phone ||
      !postalCode ||
      !supportId ||
      !startDate ||
      !endDate
    ) {
      return false;
    }
    if (
      title === "" ||
      description === "" ||
      phone === "" ||
      postalCode === "" ||
      supportId === "" ||
      startDate === "" ||
      endDate === ""
    ) {
      return false;
    }
    if (
      title.trim().length > 64 ||
      description.trim().length > 1000 ||
      address1.trim().length > 240 ||
      (address2 && address2.trim().length > 240) ||
      Math.ceil(Math.log10(phone)) < 8 ||
      Math.ceil(Math.log10(postalCode + 1)) > 10 ||
      yearsOfExperience < 0 ||
      yearsOfExperience > 99 ||
      (department && department.trim().length > 255) ||
      (floor && department.trim().length > 255)
    ) {
      return false;
    }
    if (moment.range(moment(startDate), moment(endDate)).diff("days") <= 0) {
      return false;
    }
    if (moment.range(moment(startDate), moment(endDate)).diff("days") <= 0) {
      return false;
    }
    return true;
  };
  // common Function use UTC
  const isApplyTime = (monday, sunday, timeApply) => {
    const applyStartDate = moment.utc(timeApply.applyStartDate);
    const applyEndDate = moment.utc(timeApply.applyEndDate);
    return (
      moment.range(monday, applyEndDate).diff("minutes") > 0 &&
      moment.range(applyStartDate, sunday).diff("minutes") > 0
    );
  };
  const isCheckUpdateShift = (oldShift, shift) => {
    if (shift.settingNextWeek) {
      return true;
    }
    if (
      moment(oldShift.startTime).format("HH:mm") !==
      moment(shift.startTime).format("HH:mm") ||
      moment(oldShift.endTime).format("HH:mm") !==
      moment(shift.endTime).format("HH:mm") ||
      oldShift.shiftType !== shift.shiftType ||
      oldShift.numberWorkers !== shift.numberWorkers
    ) {
      return true;
    }
    return false;
  };
  // const isCheckUpdateShiftTime = (oldShift, shift) => {
  //   if (moment(oldShift.startTime).format('HH:mm') !== moment(shift.startTime).format('HH:mm')
  //     || moment(oldShift.endTime).format('HH:mm') !== moment(shift.endTime).format('HH:mm')
  //     || oldShift.shiftType !== shift.shiftType) {
  //       return true;
  //   }
  //   return false;
  // };
  const isCheckUpdateSegment = (oldSegment, segment) => {
    if (
      moment(oldSegment.startTime).format("HH:mm") !==
      moment(segment.startTime).format("HH:mm") ||
      moment(oldSegment.endTime).format("HH:mm") !==
      moment(segment.endTime).format("HH:mm") ||
      oldSegment.shiftType !== segment.shiftType
    ) {
      return true;
    }
    return false;
  };
  // const isConflictTime = (time1, time2) => {
  //   if (moment.range(time1.startTime, time2.endTime).diff('minutes') > 0
  //   && moment.range(time2.startTime, time1.endTime).diff('minutes') > 0) {
  //       return true;
  //   }
  //   return false;
  // };

  const shiftConstructor = (item, startDate) => {
    const newStartTime =
      item.startTime || item.startTime !== ""
        ? moment(item.startTime).set({
          year: startDate.get("year"),
          month: startDate.get("month"),
          date: startDate.get("date"),
        })
        : null;
    const newEndTime =
      item.endTime || item.endTime !== ""
        ? moment(item.endTime).set({
          year: startDate.get("year"),
          month: startDate.get("month"),
          date: startDate.get("date"),
        })
        : null;

    if (newStartTime && newEndTime) {
      if (moment.range(newStartTime, newEndTime).diff("minutes") <= 0) {
        newEndTime.add(1, "days");
      }
    }
    return {
      ...item,
      startTime: newStartTime ? newStartTime.format("YYYY/MM/DD HH:mm") : null,
      endTime: newEndTime ? newEndTime.format("YYYY/MM/DD HH:mm") : null,
    };
  };

  const getDistanceToTopById = (id) => {
    const element = document.getElementById(id);
    if (element) {
      return element.offsetTop ? element.offsetTop : 0;
    }
    return 0;
  };
  const getTitleMessageDeleteShift = (str) => {
    switch (str) {
      case enumConfirmDialog.deleteShift:
      case enumConfirmDialog.deleteShiftHasBooked:
        return t("title.deleteAvailability");
      case enumConfirmDialog.deleteDayOfWeek:
      case enumConfirmDialog.deleteDayOfWeekHasBooked:
        return t("title.deleteDayOfWeek");
      case enumConfirmDialog.deleteDayOfWeekListHasBooked:
      case enumConfirmDialog.changeSettingBooking:
        return t("title.updateAvailability");
      default:
        break;
    }
  };
  const getMessageDeleteShift = (str) => {
    switch (str) {
      case enumConfirmDialog.deleteShift:
        return t("text.messageDeleteThisAvailability");
      case enumConfirmDialog.deleteDayOfWeek:
        return t("text.messageDeleteDayOfWeek");
      case enumConfirmDialog.deleteShiftHasBooked:
        return t("text.messageDeleteShiftHasBooked");
      case enumConfirmDialog.deleteDayOfWeekHasBooked:
        return t("text.messageDeleteDayOfWeekHasBooked");
      case enumConfirmDialog.deleteDayOfWeekListHasBooked:
        return t("text.messageDeleteDayOfWeekListHasBooked");
      case enumConfirmDialog.changeSettingBooking:
        return t("text.messageChangeSettingBooking");
      default:
        break;
    }
  };
  const getMinEndDate = (values) => {
    if (isAdd) {
      if (values.startDate) {
        return new Date(
          moment(new Date(values.startDate)).startOf("day").add(1, "days")
        );
      } else {
        return new Date(moment(new Date()).startOf("day").add(1, "days"));
      }
    } else if (minEndDate) {
      return new Date(moment(minEndDate).startOf("day"));
    }
  };
  const getNumberDayOfWeek = ({
    startDate,
    endDate,
    applyStartDate,
    applyEndDate,
    dayOfWeekList,
  }) => {
    let count = 0;
    let dateFrom = startDate;
    let dateTo = endDate;
    if (
      applyStartDate &&
      moment
        .range(moment.utc(applyStartDate), moment.utc(startDate))
        .diff("minutes") < 0
    ) {
      dateFrom = moment.utc(applyStartDate).format("YYYY/MM/DD");
    }
    if (applyEndDate) {
      dateTo = moment.utc(applyEndDate).format("YYYY/MM/DD");
    }
    const momentStartDate = moment(dateFrom);
    const momentEndDate = moment(dateTo);
    while (momentStartDate.isSameOrBefore(momentEndDate)) {
      for (const i in dayOfWeekList) {
        if (momentStartDate.weekday() === COUNT_WEEK_DAY[dayOfWeekList[i]]) {
          count++;
          break;
        }
      }
      momentStartDate.add(1, "day");
    }
    return count;
  };
  const getTextError = (data) => {
    const startDate = moment(data.startDate);
    // check jobAvailabilityRequests Is Empty when isAdd
    if (isAdd && data.jobAvailabilityRequests.length === 0) {
      return t("toast.error.jobAvailabilityRequestsIsEmpty");
    }
    // check conflict time
    for (let index = 0; index < data.jobAvailabilityRequests.length; index++) {
      if (
        data.jobAvailabilityRequests[index].status === "INACTIVE" ||
        (!data.jobAvailabilityRequests[index].isApply &&
          !data.jobAvailabilityRequests[index].isNew)
      ) {
        continue;
      }
      const jobAvailabilityRequest = data.jobAvailabilityRequests[index];

      const { dayOfWeek } = jobAvailabilityRequest;
      const currentShift = shiftConstructor(
        data.jobAvailabilityRequests[index],
        startDate
      );
      const availabilitySameDay = [];
      for (let i = 0; i < data.jobAvailabilityRequests.length; i++) {
        const jobAvailability = data.jobAvailabilityRequests[i];
        if (
          i !== index &&
          jobAvailability.dayOfWeek === dayOfWeek &&
          (!data.jobAvailabilityRequests[index].id ||
            data.jobAvailabilityRequests[index].id !==
            jobAvailability.parentId) &&
          jobAvailability.status !== "INACTIVE"
        ) {
          // apply from current week to endDate
          if (
            jobAvailability.isApply ||
            jobAvailability.isApplyNextWeek ||
            jobAvailability.isNew
          ) {
            // case jobAvailability current has been deleted next week
            if (!jobAvailability.isApply && jobAvailability.isApplyNextWeek) {
              const jobAvailabilityParent = data.jobAvailabilityRequests.find(
                (item) => item.id === jobAvailability.parentId
              );
              if (jobAvailabilityParent) {
                continue;
              }
            }
            // startTime and endTime apply for current week or next week
            availabilitySameDay.push({
              startTime: jobAvailability.startTime,
              endTime: jobAvailability.endTime,
              shiftType: jobAvailability.shiftType,
            });
            if (
              jobAvailability.startTime ===
              jobAvailability.startTimeCurrentWeek &&
              jobAvailability.endTime === jobAvailability.endTimeCurrentWeek
            ) {
              // case startTime and endTime apply for current week
              if (
                jobAvailability.startTimeNextWeek &&
                jobAvailability.endTimeNextWeek
              ) {
                availabilitySameDay.push({
                  startTime: jobAvailability.startTimeNextWeek,
                  endTime: jobAvailability.endTimeNextWeek,
                  shiftType: jobAvailability.shiftType,
                });
              }
            } else {
              // case startTime and endTime apply for next week
              if (
                jobAvailability.startTimeNextWeek &&
                jobAvailability.endTimeNextWeek
              ) {
                availabilitySameDay.push({
                  startTime: jobAvailability.startTimeCurrentWeek,
                  endTime: jobAvailability.endTimeCurrentWeek,
                  shiftType: jobAvailability.shiftType,
                });
              }
            }
          }
        }
      }
      const multiShiftType = availabilitySameDay.map((item) =>
        shiftConstructor(item, startDate)
      );
      // Check
      if (currentShift && currentShift.startTime && currentShift.endTime) {
        for (const i in multiShiftType) {
          if (
            multiShiftType[i].startTime &&
            multiShiftType[i].endTime &&
            multiShiftType[i].startTime === currentShift.startTime &&
            multiShiftType[i].endTime === currentShift.endTime
          ) {
            return t("toast.error.conflictTime");
          }
        }
      }
    }
    return null;
  };
  const getNumberByShift = (shiftType) => {
    switch (shiftType) {
      case "MORNING":
        return 1;
      case "AFTERNOON":
        return 2;
      case "EVENING":
        return 3;
      case "NIGHT":
        return 4;
      default:
        return 0;
    }
  };
  const sortAvailabilities = (a, b) => {
    // Sort by shift
    const aIsApplyTime = isApplyTime(
      moment.utc().startOf("isoWeek"),
      moment.utc().endOf("isoWeek"),
      a
    );
    const bIsApplyTime = isApplyTime(
      moment.utc().startOf("isoWeek"),
      moment.utc().endOf("isoWeek"),
      b
    );
    if (aIsApplyTime !== bIsApplyTime) {
      return aIsApplyTime ? -1 : 1;
    }
    const keyA = getNumberByShift(a.shiftType);
    const keyB = getNumberByShift(b.shiftType);
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    // Sort by Time
    const startTimeA = moment(a.startTime);
    const startTimeB = moment(b.startTime);
    return parseFloat(moment.range(startTimeA, startTimeB).diff("minutes")) > 0
      ? -1
      : 1;
  };

  // settingNextWeek => it only applies to the current week.
  const setupAvailability = (
    jobAvailability,
    jobAvailabilityNextWeek,
    startDate,
    endDate
  ) => {
    const clone = { ...jobAvailability };
    const { startTime, endTime, parentId, applyEndDate } = jobAvailability;
    let isApply = isApplyTime(
      moment.utc().startOf("isoWeek"),
      moment.utc().endOf("isoWeek"),
      jobAvailability
    );
    if (
      !parentId &&
      parentId !== 0 &&
      moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .isBefore(moment(startDate))
    ) {
      isApply = true;
    }

    let isApplyNextWeek =
      moment.utc(applyEndDate).endOf("isoWeek").format("YYYY/MM/DD") ===
      moment(endDate).endOf("isoWeek").format("YYYY/MM/DD");
    if (isApply) {
      // const jobAvailabilityNextWeek = newjobAvailabilitiesList.find(subItem => subItem.parentId === availability.id);
      if (jobAvailabilityNextWeek) {
        const startTimeNextWeek = moment(startDate)
          .hours(moment(jobAvailabilityNextWeek.startTime).hours())
          .minutes(moment(jobAvailabilityNextWeek.startTime).minutes());
        const endTimeNextWeek = moment(startDate)
          .hours(moment(jobAvailabilityNextWeek.endTime).hours())
          .minutes(moment(jobAvailabilityNextWeek.endTime).minutes());
        if (
          moment.range(startTimeNextWeek, endTimeNextWeek).diff("minutes") <= 0
        ) {
          endTimeNextWeek.add(1, "days");
        }
        clone["startTimeNextWeek"] = startTimeNextWeek.format(
          "YYYY/MM/DD HH:mm"
        );
        clone["endTimeNextWeek"] = endTimeNextWeek.format("YYYY/MM/DD HH:mm");
        clone["shiftTypeNextWeek"] = clone.applyShiftType;
        // setting of next week
        clone["settingNextWeek"] = {
          startTime: startTimeNextWeek.format("YYYY/MM/DD HH:mm"),
          endTime: endTimeNextWeek.format("YYYY/MM/DD HH:mm"),
          applyStartDate: jobAvailabilityNextWeek.applyStartDate,
          applyEndDate: jobAvailabilityNextWeek.applyEndDate,
          numberOfBooked: jobAvailabilityNextWeek.numberOfBooked
            ? jobAvailabilityNextWeek.numberOfBooked
            : 0,
          totalBookings: jobAvailabilityNextWeek.totalBookings
            ? jobAvailabilityNextWeek.totalBookings
            : 0,
          status: "ACTIVE",
          isApply: false,
          isApplyNextWeek: true,
          shiftTypeNextWeek: clone.applyShiftType,
          segments: setupSegmentList(
            jobAvailabilityNextWeek.segmentList,
            startDate,
            startTimeNextWeek
          ),
        };
      } else {
        clone["startTimeNextWeek"] = startTime;
        clone["endTimeNextWeek"] = endTime;
        clone["shiftTypeNextWeek"] = clone.applyShiftType;
      }
      clone["startTimeCurrentWeek"] = startTime;
      clone["endTimeCurrentWeek"] = endTime;
    }
    clone["isApply"] = isApply;
    clone["isApplyNextWeek"] = isApplyNextWeek;
    clone["segments"] = setupSegmentList(
      jobAvailability.segmentList,
      startDate,
      startTime
    );
    clone["groupByDayOfWeek"] = {};
    delete clone.id;
    delete clone.segmentList;
    delete clone.dayOfWeek;
    return { ...clone };
  };
  const setupSegmentList = (list = [], startDate, minTime) => {
    return list.map((item) => {
      const clone = { ...item };
      const momentStart = moment(item.startTime);
      const momentEnd = moment(item.endTime);
      const newStart = moment(startDate)
        .hours(momentStart.hours())
        .minutes(momentStart.minutes());
      const newEnd = moment(startDate)
        .hours(momentEnd.hours())
        .minutes(momentEnd.minutes());
      if (moment.range(minTime, newStart).diff("minutes") < 0) {
        newStart.add(1, "days");
      }
      if (moment.range(minTime, newEnd).diff("minutes") <= 0) {
        newEnd.add(1, "days");
      }
      clone["startTime"] = newStart.format("YYYY/MM/DD HH:mm:ss");
      clone["endTime"] = newEnd.format("YYYY/MM/DD HH:mm:ss");
      clone["isExpand"] = false;
      clone["status"] = "ACTIVE";
      return clone;
    });
  };

  // Group data by startTime, endTime, shiftType, numberWorkers
  const groupAvailability = (list = [], startDate, endDate) => {
    const listMap = new Map();
    const groupAvailability = [];
    const idsNextWeek = {};
    var countGroupShiftId = 0;
    var sortList = [...list];
    if (sortList.length > 1) {
      sortList.sort(sortAvailabilities);
    }

    sortList.forEach((item) => {
      var clone = { ...item };
      const momentStart = moment(item.startTime);
      const momentEnd = moment(item.endTime);
      const newStart = moment(startDate)
        .hours(momentStart.hours())
        .minutes(momentStart.minutes());
      const newEnd = moment(startDate)
        .hours(momentEnd.hours())
        .minutes(momentEnd.minutes());
      if (moment.range(newStart, newEnd).diff("minutes") <= 0) {
        newEnd.add(1, "days");
      }
      const key = `${momentStart.format("YYYY/MM/DD-HH:mm")}-${momentEnd.format(
        "YYYY/MM/DD-HH:mm"
      )}-${item.shiftType}-${item.numberWorkers}`;
      // check it is not Availability of next week
      if (!idsNextWeek[item.id]) {
        // find jobAvailability Next Week of this item
        const jobAvailabilityNextWeek = list.filter(
          (subItem) => subItem.parentId === item.id
        )[0];
        clone["startTime"] = newStart.format("YYYY/MM/DD HH:mm");
        clone["endTime"] = newEnd.format("YYYY/MM/DD HH:mm");
        clone = setupAvailability(
          clone,
          jobAvailabilityNextWeek,
          startDate,
          endDate
        );

        if (!clone.isApply) {
          return;
        }

        if (listMap.has(key)) {
          // old group
          clone = listMap.get(key);
          if (
            ((item.numberOfBooked || item.numberOfBooked === 0) &&
              clone.numberOfBooked) ||
            clone.numberOfBooked === 0
          ) {
            clone["numberOfBooked"] += item.numberOfBooked;
          }
          if (
            ((item.totalBookings || item.totalBookings === 0) &&
              clone.totalBookings) ||
            clone.totalBookings === 0
          ) {
            clone["totalBookings"] += item.totalBookings;
          }
          if (jobAvailabilityNextWeek && clone["settingNextWeek"]) {
            // add numberOfBooked of jobAvailabilityNextWeek
            if (
              ((jobAvailabilityNextWeek.numberOfBooked ||
                jobAvailabilityNextWeek.numberOfBooked === 0) &&
                clone.numberOfBooked) ||
              clone.numberOfBooked === 0
            ) {
              clone["settingNextWeek"].numberOfBooked +=
                jobAvailabilityNextWeek.numberOfBooked;
              // clone['numberOfBooked'] += jobAvailabilityNextWeek.numberOfBooked;
            }
            // add totalBookings of jobAvailabilityNextWeek
            if (
              ((jobAvailabilityNextWeek.totalBookings ||
                jobAvailabilityNextWeek.totalBookings === 0) &&
                clone.totalBookings) ||
              clone.totalBookings === 0
            ) {
              clone["settingNextWeek"].totalBookings +=
                jobAvailabilityNextWeek.totalBookings;
              // clone['totalBookings'] += jobAvailabilityNextWeek.totalBookings;
            }
          }
        } else {
          // count group
          countGroupShiftId += 1;
        }

        // set data for this dayOfWeek
        clone.groupByDayOfWeek[item.dayOfWeek] = {
          id: item.id,
          status: item.status,
          isBooked: !!(item.numberOfBooked && item.numberOfBooked > 0),
        };
        if (jobAvailabilityNextWeek) {
          idsNextWeek[jobAvailabilityNextWeek.id] = true;
          // add idNextWeek for group day of week
          clone.groupByDayOfWeek[item.dayOfWeek].idNextWeek =
            jobAvailabilityNextWeek.id;
          // set isBooked if jobAvailabilityNextWeek has booked
          if (
            jobAvailabilityNextWeek.numberOfBooked &&
            jobAvailabilityNextWeek.numberOfBooked > 0
          ) {
            clone.groupByDayOfWeek[item.dayOfWeek].isBooked = true;
          }
        }
        listMap.set(key, clone);
      }
      // else {
      //   if (listMap.has(key)) {
      //     clone = listMap.get(key)
      //     if ((item.numberOfBooked || item.numberOfBooked === 0) && clone.numberOfBooked || clone.numberOfBooked === 0) {
      //       clone['numberOfBooked'] += item.numberOfBooked;
      //     }
      //     if ((item.totalBookings || item.totalBookings === 0) && clone.totalBookings || clone.totalBookings === 0) {
      //       clone['totalBookings'] += item.totalBookings;
      //     }
      //   }
      // }
    });
    listMap.forEach((item) =>
      groupAvailability.push({ ...item, countGroupShiftId })
    );
    return groupAvailability;
  };
  const unGroupAvailability = (groupData = []) => {
    const list = [];
    for (let i = 0; i < groupData.length; i++) {
      const {
        groupByDayOfWeek,
        startTime,
        endTime,
        isApplyNextWeek,
        applyStartDate,
        applyEndDate,
        settingNextWeek,
        ...data
      } = groupData[i];
      delete data.startTimeCurrentWeek;
      delete data.endTimeCurrentWeek;
      delete data.startTimeNextWeek;
      delete data.endTimeNextWeek;
      delete data.countGroupShiftId;

      Object.keys(groupByDayOfWeek).forEach((key) => {
        if (groupByDayOfWeek[key]) {
          list.push({
            ...data,
            isApplyNextWeek,
            applyStartDate,
            applyEndDate,
            startTime,
            endTime,
            dayOfWeek: key,
            id: groupByDayOfWeek[key].id,
          });
          if (
            settingNextWeek &&
            settingNextWeek.isApplyNextWeek &&
            (groupByDayOfWeek[key].idNextWeek ||
              groupByDayOfWeek[key].idNextWeek === 0)
          ) {
            list.push({
              ...data,
              ...settingNextWeek,
              dayOfWeek: key,
              id: groupByDayOfWeek[key].idNextWeek,
            });
          }
        }
      });
    }
    return list;
  };

  const loadWorkersApplied = async () => {
    const result = await dispatch(getWorkerApplied({ jobId: jobId }));
    if (result.payload) {
      setWorkersApplied(result.payload);
    } else {
      history.push("/admin/jobs");
    }
  };
  const loadSupports = async () => {
    await dispatch(fetchSupports());
  };
  const loadClientIds = async () => {
    const result = await dispatch(fetchClientList(companyId));
    if (result.payload) {
      setClientIds(result.payload);
    }
  };
  const _loadData = async () => {
    setIsLoading(true);
    const result = await dispatch(fetchJobDetail({ id: jobId }));
    const { payload } = result;
    if (payload) {
      let isCheckBooked = false;
      const data = { ...initializeData };
      const {
        jobAvailabilities = [],
        startDate = "",
        endDate = "",
        isPostJob,
        specialty = {},
        accreditation = {},
        support = {},
        client = {},
        yearsOfExperience,
        isAllowDelete,
        isAllowEndJob,
      } = payload;

      Object.keys(initializeData).forEach((key) => {
        data[key] = payload[key] || "";
      });
      if (client) {
        data["clientType"] = client.clientType;
        data["clientId"] = client.id;
        data["client"] = client;
      }
      const newjobAvailabilitiesList = groupAvailability(
        jobAvailabilities,
        startDate,
        endDate
      );
      data["jobAvailabilityRequests"] = newjobAvailabilitiesList.map((item) => {
        const clone = { ...item };
        const {
          numberOfBooked,
          applyStartDate,
          applyEndDate,
          groupByDayOfWeek,
        } = item;
        if (numberOfBooked > 0) {
          isCheckBooked = true;
        }
        clone["numberDayOfWeek"] = getNumberDayOfWeek({
          startDate,
          endDate,
          applyStartDate,
          applyEndDate,
          dayOfWeekList: Object.keys(groupByDayOfWeek),
        });
        return clone;
      });
      data["specialtyId"] = specialty.id;
      if (client.id) {
        data["billingDetail"] = client.billingDetail;
        data["billToAddress"] = client.billToAddress;
        if (client.billingDetail === BILLING_TYPE.PLAN_MANAGER.id) {
          data["planManagerOrganizationName"] =
            client.planManagerOrganizationName;
          data["planManagerPhone"] = client.planManagerPhone;
          data["planManagerEmail"] = client.planManagerEmail;
        }
      }

      data["isPostJob"] = isPostJob ? POST_JOB.POST_JOB : POST_JOB.UNPOST_JOB;
      data["accreditationId"] = accreditation.id;
      data["supportId"] = support.id;
      data["startDate"] = moment(startDate).format("YYYY/MM/DD");
      data["endDate"] = moment(endDate).format("YYYY/MM/DD");
      data["yearsOfExperience"] = yearsOfExperience;
      data["isAllowDelete"] = isAllowDelete;
      data["isAllowEndJob"] = isAllowEndJob;
      if (moment.range(moment(), moment(startDate)).diff("minutes") > 0) {
        setMinEndDate(moment(startDate).add(1, "days").format("YYYY/MM/DD"));
      } else {
        setMinEndDate(moment().add(1, "days").format("YYYY/MM/DD"));
      }

      setInitializeData(data);
      setJobType(payload.jobType);
      // setJobAvailabilityList(unGroupAvailability(newjobAvailabilitiesList));
      setJobAvailabilityList(jobAvailabilities);
      setIsBooked(isCheckBooked);
      loadWorkersApplied();
    } else {
      setIsLoading(false);
      history.push("/admin/jobs");
    }
    setIsLoading(false);
  };

  const segmentValidate = Yup.object().shape(
    {
      endTime: Yup.date()
        .required("validation.required")
        .when("startTime", (startTime, schema) => {
          if (startTime && startTime !== "") {
            return schema.min(
              moment(startTime).add(1, "minutes").format("yyyy/MM/DD HH:mm"),
              "validation.endTimeMustBeAfterStartTime"
            );
          }
        }),
      startTime: Yup.date()
        .required("validation.required")
        .when("endTime", (endTime, schema) => {
          if (endTime && endTime !== "") {
            return schema.max(
              moment(endTime).subtract(1, "minutes").format("yyyy/MM/DD HH:mm"),
              "validation.startTimeMustBeBeforeEndTime"
            );
          }
        }),
      shiftType: Yup.string().required("validation.required"),
    },
    // determine relationship
    [
      ["startTime", "endTime"],
      ["endTime", "startTime"],
    ]
  );
  // .test("duplicates-shift-type", "validation.duplicatesShiftType", function (segment) {
  //   const { path, createError } = this;
  //   const segments = this.parent;
  //   if (!segments) return true;
  //   // test shift type
  //   const shiftTypes = segments.map(seg => seg.shiftType);
  //   if (shiftTypes.indexOf(segment.shiftType) !== shiftTypes.lastIndexOf(segment.shiftType)) {
  //     return createError({ path: `${path}.shiftType`, message: t("validation.duplicatesShiftType") });
  //   }
  //   return true;
  // });

  const shiftValidate = Yup.object().shape(
    {
      startTime: Yup.date().when("status", (status) => {
        if (!status || status !== "INACTIVE") {
          return Yup.date()
            .required("validation.required")
            .when("endTime", (endTime, schema) => {
              if (endTime && endTime !== "") {
                return schema.max(
                  moment(endTime)
                    .subtract(1, "minutes")
                    .format("yyyy/MM/DD HH:mm"),
                  "validation.startTimeMustBeBeforeEndTime"
                );
              }
            });
        }
      }),
      endTime: Yup.date().when("status", (status) => {
        if (!status || status !== "INACTIVE") {
          return Yup.date()
            .required("validation.required")
            .when("startTime", (startTime, schema) => {
              if (startTime && startTime !== "") {
                return schema.min(
                  moment(startTime)
                    .add(1, "minutes")
                    .format("yyyy/MM/DD HH:mm"),
                  "validation.endTimeMustBeAfterStartTime"
                );
              }
            });
        }
      }),
      shiftType: Yup.string().when("status", (status) => {
        if (!status || status !== "INACTIVE") {
          return Yup.string().required("validation.required");
        }
      }),
      numberWorkers: Yup.number().when("status", (status) => {
        if (!status || status !== "INACTIVE") {
          return Yup.number().when(
            ["id", "startTime", "endTime", "numberOfBooked", "numberDayOfWeek"],
            function (id, startTime, endTime, numberOfBooked, numberDayOfWeek) {
              let minimun = 1;
              if (
                id &&
                numberOfBooked &&
                startTime &&
                endTime &&
                numberDayOfWeek &&
                jobAvailabilityList
              ) {
                const jobAvailability = jobAvailabilityList.find(
                  (item) => item.id === id
                );
                if (
                  jobAvailability &&
                  moment(jobAvailability.startTime).isSame(moment(startTime)) &&
                  moment(jobAvailability.endTime).isSame(moment(endTime))
                ) {
                  minimun = Math.ceil(numberOfBooked / numberDayOfWeek);
                }
              }
              return Yup.number()
                .required("validation.required")
                .min(minimun, {
                  message: "validation.minValue",
                  value: minimun,
                })
                .max(100, { message: "validation.maxValue", value: 100 });
            }
          );
        }
      }),
      segments: Yup.array().of(segmentValidate),
    },
    // determine relationship
    [
      ["startTime", "endTime"],
      ["endTime", "startTime"],
    ]
  );
  const validationSchema = Yup.object().shape({
    clientId: Yup.string().required("validation.required"),
    title: YupValidations.requiredString.max(64, "validation.max_length_64"),
    description: Yup.string()
      .trim()
      .required("validation.required")
      .max(1000, "validation.max_length_1000"),
    address1: YupValidations.requiredString,
    address2: Yup.string().max(240, "validation.max_length_240"),
    phone: YupValidations.phone,
    postalCode: YupValidations.postalCode,
    supportId: Yup.string().required("validation.required"),
    yearsOfExperience: Yup.number()
      .min(0, { message: "validation.minValue", value: 0 })
      .integer()
      .nullable(true)
      .max(99, { message: "validation.maxValue", value: 99 }),
    startDate: Yup.date().required("validation.required"),
    endDate: Yup.date()
      .required("validation.required")
      .when(
        "startDate",
        (startDate, schema) =>
          startDate &&
          schema.min(
            moment(startDate).format("YYYY/MM/DD HH:mm"),
            "validation.endDateMustBeGreaterThanStartDate"
          )
      ),
    jobAvailabilityRequests: Yup.array().of(shiftValidate),
    department: Yup.string().nullable().max(255, "validation.max_length_255"),
    floor: Yup.string().nullable().max(255, "validation.max_length_255"),
  });

  // Handle Function
  const handleRemoveWorker = async ({ workerId }) => {
    await dispatch(
      jobRemoveWorker({
        jobId: jobId,
        workerId,
      })
    );
    loadWorkersApplied();
  };
  const handleAutoBooking = async () => {
    setIsLoading(true);
    await dispatch(autoBooking({ jobId: jobId }));
    setIsLoading(false);
    _loadData();
    setIsOpenModalAutoBooking(false);
  };
  const handleStartDateChange = (date, values, handleChange) => {
    // const newDate = moment(date);
    if (!values.jobAvailabilityRequests || !date || date === "") {
      return;
    }
    const { startDate, endDate, applyStartDate, applyEndDate } = values;
    let newJobAvailabilityRequests = values.jobAvailabilityRequests.map(
      (value) => {
        if ((startDate, endDate)) {
          value.numberDayOfWeek = getNumberDayOfWeek({
            startDate,
            endDate,
            applyStartDate,
            applyEndDate,
            dayOfWeekList: Object.keys(value.groupByDayOfWeek),
          });
        }

        const newStartTime = moment(date).set({
          hour: moment(value.startTime).hours(),
          minute: moment(value.startTime).minutes(),
          second: moment(value.startTime).seconds(),
        });
        const newEndTime = moment(date).set({
          hour: moment(value.endTime).hours(),
          minute: moment(value.endTime).minutes(),
          second: moment(value.endTime).seconds(),
        });

        if (moment.range(newStartTime, newEndTime).diff("minutes") <= 0) {
          newEndTime.add(1, "days");
        }
        // if (value.shiftType === 'NIGHT' || value.shiftType === 'EVENING') {
        //   if (newEndTime.hours() < 6 || (newEndTime.hours() === 6 && newEndTime.minutes() === 0)) {
        //     newEndTime.add(1, 'days')
        //   }
        //   if (newStartTime.hours() < 6) {
        //     newStartTime.add(1, 'days')
        //   }
        // }

        return {
          ...value,
          startTime: newStartTime.format("YYYY/MM/DD HH:mm"),
          endTime: newEndTime.format("YYYY/MM/DD HH:mm"),
        };
      }
    );
    handleChange({
      target: {
        name: "jobAvailabilityRequests",
        value: newJobAvailabilityRequests,
      },
    });
    if (moment.range(moment(), moment(date)).diff("minutes") > 0) {
      setMinEndDate(moment(date).add(1, "days").format("YYYY/MM/DD"));
    } else {
      setMinEndDate(moment().add(1, "days").format("YYYY/MM/DD"));
    }
  };
  const handleEndDateChange = (date, values, handleChange) => {
    if (!values.jobAvailabilityRequests || !date || date === "") {
      return;
    }
    const { startDate, endDate, applyStartDate, applyEndDate } = values;
    if ((startDate, endDate)) {
      let newJobAvailabilityRequests = values.jobAvailabilityRequests.map(
        (value) => {
          const numberDayOfWeek = getNumberDayOfWeek({
            startDate,
            endDate,
            applyStartDate,
            applyEndDate,
            dayOfWeekList: Object.keys(value.groupByDayOfWeek),
          });
          return {
            ...value,
            numberDayOfWeek,
          };
        }
      );
      handleChange({
        target: {
          name: "jobAvailabilityRequests",
          value: newJobAvailabilityRequests,
        },
      });
    }
  };
  const handleShowPopupDeleteShift = async (ids, isHasBooked) => {
    setIdsDeleteAvailability(ids);
    setMessageDeleteAvailabilityModal(
      isHasBooked
        ? enumConfirmDialog.deleteShiftHasBooked
        : enumConfirmDialog.deleteShift
    );
  };
  // const handleGetAllCanceledBooking = async (data, formData, isApplySettingNextWeek) => {
  //   const { groupByDayOfWeek, numberOfBooked, index } = data;
  //   const idsUpdate = [];
  //   const idsDelete = [];
  //   const oldShift = initializeData.jobAvailabilityRequests[index];
  //   const isUpdateShiftSetting = isCheckUpdateShift(oldShift, data);
  //   Object.keys(groupByDayOfWeek).forEach(day => {
  //     if (groupByDayOfWeek[day]) {
  //       // old availability
  //       if (groupByDayOfWeek[day].id || groupByDayOfWeek[day].id === 0) {
  //         if (groupByDayOfWeek[day].status === 'INACTIVE') {
  //           idsDelete.push({ id: groupByDayOfWeek[day].id });
  //         } else if (isUpdateShiftSetting) {
  //           idsUpdate.push(groupByDayOfWeek[day].id);
  //         }
  //       }
  //     }
  //   });

  //   // Check data
  //   let isUpdateEndDate = !moment(formData.endDate).isSame(moment(initializeData.endDate));

  //   // on call API
  //   if (numberOfBooked > 0 || isUpdateEndDate) {
  //     const result = await dispatch(getAllCanceledBooking({
  //       jobId: jobId,
  //       idsUpdate: idsUpdate,
  //       idsDelete: idsDelete,
  //       newEndDate: formData.endDate,
  //     }))
  //     const { payload } = result;

  //     if (payload) {
  //       if (payload.length > 0) {
  //         // sort
  //         let data = [...payload];
  //         data.sort(function(a, b){return moment.range(moment(b.date), moment(a.date)).diff('minutes')});
  //         setBookingCanceledList(data);
  //         setShowBookingCanceledList(true);
  //       } else {
  //         handleUpdateShift(dataUpdateShift, isApplySettingNextWeek);
  //       }
  //     }
  //   } else {
  //     handleUpdateShift(dataUpdateShift, isApplySettingNextWeek);
  //   }
  //   setIsLoading(false);
  // }
  const handleUpdateJobInfo = (formData) => {
    if (!isValidJobInfo(formData)) {
      return null;
    }
    const requestParam = {
      id: jobId,
      title: formData.title,
      description: formData.description,
      department: formData.department,
      floor: formData.floor,
      postalCode: formData.postalCode,
      phone: formData.phone,
      address1: formData.address1,
      address2: formData.address2,
      startDate: formData.startDate,
      endDate: formData.endDate,
      supportId: formData.supportId,
      isPostJob: formData.isPostJob === POST_JOB.POST_JOB ? true : false,
      yearsOfExperience:
        formData.yearsOfExperience === "" ? 0 : formData.yearsOfExperience,
      lat,
      lng,
    };
    onUpdateJobInfo(requestParam);
  };
  const handleChangeDayOfWeek = async (
    data,
    oldData,
    dayOfWeek,
    isAddDayOfWeek
  ) => {
    const { groupByDayOfWeek = {} } = data;
    const addDeleteAvailabilityRequestList = [];
    const previousAvailabilityIdList = [];
    if (isAddDayOfWeek) {
      Object.keys(groupByDayOfWeek).forEach((day) => {
        previousAvailabilityIdList.push(groupByDayOfWeek[day].id);
        addDeleteAvailabilityRequestList.push({
          id: groupByDayOfWeek[day].id,
          daysOfWeek: day,
          endTime: oldData.endTime,
          startTime: oldData.startTime,
          shiftType: oldData.shiftType,
          numberWorkers: oldData.numberWorkers,
          status: groupByDayOfWeek[day].status,
        });
      });
      addDeleteAvailabilityRequestList.push({
        daysOfWeek: dayOfWeek,
        endTime: oldData.endTime,
        startTime: oldData.startTime,
        shiftType: oldData.shiftType,
        numberWorkers: oldData.numberWorkers,
        status: "ACTIVE",
      });
      const params = {
        jobId,
        previousAvailabilityIdList,
        addDeleteAvailabilityRequestList,
      };
      await onUpdateDayOfWeekOnShiftSetting(params, false, false);
    } else if (
      groupByDayOfWeek[dayOfWeek] &&
      (groupByDayOfWeek[dayOfWeek].id || groupByDayOfWeek[dayOfWeek].id === 0)
    ) {
      Object.keys(groupByDayOfWeek).forEach((day) => {
        previousAvailabilityIdList.push(groupByDayOfWeek[day].id);
        addDeleteAvailabilityRequestList.push({
          id: groupByDayOfWeek[day].id,
          daysOfWeek: day,
          endTime: oldData.endTime,
          startTime: oldData.startTime,
          shiftType: oldData.shiftType,
          numberWorkers: oldData.numberWorkers,
          status: dayOfWeek === day ? "INACTIVE" : groupByDayOfWeek[day].status,
        });
      });
      const params = {
        jobId,
        previousAvailabilityIdList,
        addDeleteAvailabilityRequestList,
      };
      setParamsDeleteDayOfWeek(params);
      // setIdsDeleteAvailability([groupByDayOfWeek[dayOfWeek].id]);
      setMessageDeleteAvailabilityModal(
        groupByDayOfWeek[dayOfWeek].isBooked
          ? enumConfirmDialog.deleteDayOfWeekHasBooked
          : enumConfirmDialog.deleteDayOfWeek
      );
    }
  };
  const handleDeleteShift = async () => {
    if (!idsDeleteAvailability || idsDeleteAvailability.length === 0) {
      return null;
    }
    const deleteJobAvailabilityRequestList = idsDeleteAvailability.map(
      (item) => {
        return { id: item };
      }
    );
    const params = {
      jobId: Number(jobId),
      deleteJobAvailabilityRequestList,
    };
    await onDeleteShift(params);
  };
  const handleDeleteDayOfWeek = async () => {
    if (paramsDeleteDayOfWeek) {
      await onUpdateDayOfWeekOnShiftSetting(
        paramsDeleteDayOfWeek,
        false,
        false
      );
      setParamsDeleteDayOfWeek(null);
      setMessageDeleteAvailabilityModal(null);
    }
  };
  const handleCreateUpdateShift = (data) => {
    const { groupByDayOfWeek = {} } = data;
    var isUpdateShift = false;
    var isDeleteBooked = false;
    var isHasBookedUpdate = false;

    Object.keys(groupByDayOfWeek).forEach((day) => {
      if (
        groupByDayOfWeek[day] &&
        (groupByDayOfWeek[day].id || groupByDayOfWeek[day].id === 0)
      ) {
        isUpdateShift = true;
        if (
          groupByDayOfWeek[day].status === "INACTIVE" &&
          groupByDayOfWeek[day].isBooked
        ) {
          isDeleteBooked = true;
        }
        if (
          groupByDayOfWeek[day].status === "ACTIVE" &&
          groupByDayOfWeek[day].isBooked
        ) {
          isHasBookedUpdate = true;
        }
      }
    });
    // Update
    if (isUpdateShift) {
      if (!isValidShift(data)) {
        return null;
      }
      const oldShift = initializeData.jobAvailabilityRequests[data.index];
      const sundayCurrentWeek = moment()
        .endOf("isoWeek")
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0);
      const isBeforeStartDate =
        moment
          .range(
            moment(jobDetail.startDate)
              .hours(0)
              .minutes(0)
              .seconds(0)
              .milliseconds(0),
            sundayCurrentWeek
          )
          .diff("hours") < 0;
      const isUpdateShiftSetting = isCheckUpdateShift(oldShift, data);
      // isChangeSettingForBooking is case change setting of Availability when it has booked and it before Start Date
      const isChangeSettingForBooking =
        isUpdateShiftSetting && isHasBookedUpdate && isBeforeStartDate;

      // check in groupByDayOfWeek has booked is INACTIVE to show deleted booked
      if (isDeleteBooked || isChangeSettingForBooking) {
        if (isChangeSettingForBooking) {
          setMessageDeleteAvailabilityModal(
            enumConfirmDialog.changeSettingBooking
          );
        } else if (isDeleteBooked) {
          setMessageDeleteAvailabilityModal(
            enumConfirmDialog.deleteDayOfWeekListHasBooked
          );
        }
        setDataUpdateShift(data);
      }
      // isChangeSettingForBooking will not show modal select week
      if (!isChangeSettingForBooking) {
        if (
          (isUpdateShiftSetting && isHasBookedUpdate) ||
          data.settingNextWeek
        ) {
          // shift change shift type, start time, end time and has booked or has next week to show select choose current or next week
          setDataUpdateShift(data);
          setShowModalSelectCurrentOrNextWeek(true);
        } else {
          if (!isDeleteBooked) {
            handleUpdateShift(data, false, isUpdateShiftSetting);
          }
        }
      }
    } else {
      // create
      onAddShift(data);
    }
  };
  const handleUpdateShift = async (
    data,
    isApplySettingNextWeek,
    isUpdateShiftType
  ) => {
    if (!data) {
      return null;
    }
    // set loading here
    setIsLoading(true);
    setIsUpdating(true);
    const {
      numberWorkers,
      shiftType,
      startTime,
      endTime,
      segments,
      groupByDayOfWeek,
      index,
      settingNextWeek,
    } = data;

    const oldShift = initializeData.jobAvailabilityRequests[index];
    setDataUpdateShift(null);
    setShowConfirmSelectedNextOrCurrent(false);
    setShowModalSelectCurrentOrNextWeek(false);
    if (!oldShift) {
      return null;
    }
    var previousIds = [];
    var previousNextWeekIds = [];
    var segmentsUpdate = [];
    const daysOfWeekAdd = [];
    const cloneInit = { ...initializeData };
    var isUpdateDayOfWeek = false;
    var isUpdateShiftSegments = true;
    var isUpdateShiftSetting = isCheckUpdateShift(oldShift, data);
    const distanceToTop = getDistanceToTopById(
      "title-job-availability-request"
    );

    // check update day of week
    Object.keys(groupByDayOfWeek).forEach((day) => {
      if (groupByDayOfWeek[day]) {
        // old availability id
        if (groupByDayOfWeek[day].id || groupByDayOfWeek[day].id === 0) {
          previousIds.push(groupByDayOfWeek[day].id);
          if (
            groupByDayOfWeek[day].idNextWeek ||
            groupByDayOfWeek[day].idNextWeek === 0
          ) {
            previousNextWeekIds.push(groupByDayOfWeek[day].idNextWeek);
          }
          if (groupByDayOfWeek[day].status !== "ACTIVE") {
            isUpdateDayOfWeek = true;
          }
        } else {
          // new availability
          isUpdateDayOfWeek = true;
        }
        // shift list change dayOfWeek (add or delete)
        const shiftAdd = {
          daysOfWeek: day,
          endTime: oldShift.endTime,
          startTime: oldShift.startTime,
          shiftType: oldShift.shiftType,
          numberWorkers: oldShift.numberWorkers,
          ...groupByDayOfWeek[day],
        };
        delete shiftAdd.booked;
        daysOfWeekAdd.push(shiftAdd);
      }
    });
    // check segment
    for (let i = 0; i < segments.length; i++) {
      if (segments[i].status === "ACTIVE") {
        segmentsUpdate.push(segments[i]);
      }
      if (!segments[i].id) {
        // is new Segment
        isUpdateShiftSegments = true;
      } else if (isUpdateShiftType) {
        isUpdateShiftSegments = true;
      } else {
        // is delete Segment
        if (segments[i].status === "INACTIVE") {
          isUpdateShiftSegments = true;
        }
        // is update Segment
        // get old Segment by id
        const oldSegment = oldShift.segments.filter(
          (item) => item.id === segments[i].id
        )[0];

        if (oldSegment && isCheckUpdateSegment(oldSegment, segments[i])) {
          isUpdateShiftSegments = true;
        }
      }
    }
    // delete all segment
    if (
      (oldShift.segments && oldShift.segments.length !== segments.length) ||
      settingNextWeek
    ) {
      isUpdateShiftSegments = true;
    }

    if (isUpdateDayOfWeek || isUpdateShiftSetting || isUpdateShiftSegments) {
      setSubmitting(true);
    }

    // call API update day of week
    if (isUpdateDayOfWeek) {
      const paramsAddDayOfWeek = {
        jobId: jobId,
        previousAvailabilityIdList: previousIds,
        addDeleteAvailabilityRequestList: daysOfWeekAdd,
      };
      const resultUpdateDayOfWeek = await onUpdateDayOfWeekOnShiftSetting(
        paramsAddDayOfWeek,
        true,
        isUpdateShiftSetting || isUpdateShiftSegments
      );
      if (resultUpdateDayOfWeek.payload) {
        previousNextWeekIds = [];
        previousIds = [];
        for (const item of resultUpdateDayOfWeek.payload) {
          let isApply = isApplyTime(
            moment.utc().startOf("isoWeek"),
            moment.utc().endOf("isoWeek"),
            item
          );
          if (
            !item.parentId &&
            item.parentId !== 0 &&
            moment()
              .hours(0)
              .minutes(0)
              .seconds(0)
              .milliseconds(0)
              .isBefore(moment(jobDetail.startDate))
          ) {
            isApply = true;
          }
          if (isApply) {
            // get new ids current week
            previousIds.push(item.id);
          } else if (
            moment
              .utc(item.applyEndDate)
              .endOf("isoWeek")
              .format("YYYY/MM/DD") ===
            moment(jobDetail.endDate).endOf("isoWeek").format("YYYY/MM/DD")
          ) {
            // get new ids next week
            previousNextWeekIds.push(item.id);
          }
        }
      } else {
        setInitializeData(cloneInit);
        setSubmitting(false);
        setIsSelectedNextWeek(false);
        AppUtil.scrollByIdAndTopDistance("main-panel", distanceToTop);
        return null;
      }
    }

    // call API update availability setting
    if (isUpdateShiftSetting) {
      const paramsUpdateAvailability = {
        jobId: Number(jobId),
        newEndTime: endTime,
        newStartTime: startTime,
        shiftType: shiftType,
        numberOfWorker: numberWorkers,
        jobAvailabilityIdList: previousIds,
        isApplyNextWeek: isApplySettingNextWeek,
        shiftTypeSegmentList: segmentsUpdate.map((item) => item.shiftType),
      };
      // has availability next week and user select next week
      if (previousNextWeekIds.length > 0 && isApplySettingNextWeek === true) {
        paramsUpdateAvailability.jobAvailabilityIdList = previousNextWeekIds;
        paramsUpdateAvailability.isApplyNextWeek = null;
      }

      const resultUpdateShift = await onUpdateShiftSetting(
        paramsUpdateAvailability,
        true,
        isUpdateShiftSegments
      );
      // check new id when this API create new JA for next week
      if (
        resultUpdateShift.payload &&
        isApplySettingNextWeek &&
        !settingNextWeek
      ) {
        previousNextWeekIds = [];
        for (const item of resultUpdateShift.payload) {
          if (
            (item.parentId || item.parentId === 0) &&
            previousIds.includes(item.parentId)
          ) {
            previousNextWeekIds.push(item.id);
          }
        }
      } else if (!resultUpdateShift.payload) {
        setInitializeData({});
        _loadData();
        setSubmitting(false);
        setIsSelectedNextWeek(false);
        AppUtil.scrollByIdAndTopDistance("main-panel", distanceToTop);
        return null;
      }
    }

    // call API update segments of availability

    if (isUpdateShiftSegments || isUpdateShiftSetting) {
      const paramsUpdateShiftSegments = {
        jobId: Number(jobId),
        jobAvailabilityIdList: [...previousIds],
        updateAvailabilitySegmentRequestList: segmentsUpdate,
      };
      if (previousNextWeekIds.length > 0 && isApplySettingNextWeek === true) {
        paramsUpdateShiftSegments.jobAvailabilityIdList = previousNextWeekIds;
      }
      await onUpdateShiftSegments(paramsUpdateShiftSegments);
    }
    // update loading
    setIsLoading(false);
    setIsUpdating(false);
    // load new data and the end
    if (isUpdateDayOfWeek || isUpdateShiftSetting || isUpdateShiftSegments) {
      setInitializeData({});
      _loadData();
      setSubmitting(false);
      setIsSelectedNextWeek(false);
      AppUtil.scrollByIdAndTopDistance("main-panel", distanceToTop);
    }
  };

  const _handleDeleteOrEndJob = async () => {
    setIsLoading(true);
    switch (showDeleteOrEndJobModal) {
      case "end_job":
        await dispatch(reduceEndJob({ jobId: jobDetail.id }));
        _loadData();
        setIsLoading(false);
        break;
      case "delete_job":
        await dispatch(reduceDeleteJob({ ids: [jobDetail.id] }));
        setIsLoading(false);
        history.push("/admin/jobs");
        break;
      default:
        break;
    }
    setShowDeleteOrEndJobModal(null);
  };

  const _submitCreate = async (data) => {
    let newData = { ...data };
    if (!data.jobAvailabilityRequests) {
      return null;
    }
    for (let i = 0; i < data.jobAvailabilityRequests.length; i++) {
      if (
        Object.keys(data.jobAvailabilityRequests[i].groupByDayOfWeek).length ===
        0
      ) {
        return null;
      }
    }
    const availabilityList = unGroupAvailability(data.jobAvailabilityRequests);
    newData.jobAvailabilityRequests = availabilityList;
    setSubmitting(true);
    const result = await dispatch(reduceCreateJob(newData));
    setSubmitting(false);
    if (result.payload) {
      AppUtil.scrollToTopById("main-panel");
      history.push(`detail/${result.payload.id}`);
    }
  };

  const onUpdateJobInfo = async (data) => {
    const cloneInit = { ...initializeData };
    const newData = { ...data };
    delete newData.jobAvailabilityRequests;
    setSubmitting(true);
    const result = await dispatch(updateInformationJob({ ...newData }));
    if (result.payload) {
      _loadData();
    } else {
      setInitializeData(cloneInit);
    }
    setSubmitting(false);
  };
  const onAddShift = async (data) => {
    const {
      numberWorkers,
      shiftType,
      startTime,
      endTime,
      segments,
      groupByDayOfWeek,
    } = data;
    if (!isValidShift(data)) {
      return null;
    }
    const distanceToTop = getDistanceToTopById(
      "title-job-availability-request"
    );
    const addJobAvailabilityRequestList = [];
    Object.keys(groupByDayOfWeek).forEach((day) => {
      addJobAvailabilityRequestList.push({
        numberWorkers,
        shiftType,
        startTime,
        endTime,
        segments: segments,
        dayOfWeek: day,
      });
    });
    const params = {
      jobId: jobId,
      addJobAvailabilityRequestList,
    };

    const cloneInit = { ...initializeData };
    setSubmitting(true);
    const result = await dispatch(addNewShiftSetting({ ...params }));
    if (result.payload) {
      _loadData();

      AppUtil.scrollByIdAndTopDistance("main-panel", distanceToTop);
    } else {
      setInitializeData(cloneInit);
    }
    setSubmitting(false);
  };
  const onUpdateShiftSetting = async (
    params,
    isUpdateShift,
    isNotShowNotification
  ) => {
    const cloneInit = { ...initializeData };
    if (!isUpdateShift) {
      setSubmitting(true);
    }
    const result = await dispatch(
      updateShiftSetting({ ...params, isNotShowNotification })
    );
    if (!result.payload) {
      setIsLoading(false);
      setIsUpdating(false);
      _loadData();
    }
    console.log('result', result)
    if (!isUpdateShift) {
      if (result.payload) {
        _loadData();
      } else {
        setInitializeData(cloneInit);
      }
      setSubmitting(false);
    } else {
      return result;
    }
  };
  const onUpdateShiftSegments = async (params) => {
    const result = await dispatch(updateShiftSegment({ ...params }));
    return result;
  };
  const onUpdateDayOfWeekOnShiftSetting = async (
    params,
    isUpdateShift,
    isNotShowNotification
  ) => {
    const cloneInit = { ...initializeData };
    if (!isUpdateShift) {
      setSubmitting(true);
    }
    const result = await dispatch(
      addOrDeleteShiftSetting({ ...params, isNotShowNotification })
    );

    if (!isUpdateShift) {
      if (result.payload) {
        _loadData();
      } else {
        setInitializeData(cloneInit);
      }
      setSubmitting(false);
    } else {
      return result;
    }
  };
  const onDeleteShift = async (params) => {
    const cloneInit = { ...initializeData };
    setSubmitting(true);
    const result = await dispatch(deleteShiftSetting({ ...params }));
    setIdsDeleteAvailability([]);
    setMessageDeleteAvailabilityModal(null);
    if (result.payload) {
      _loadData();
    } else {
      setInitializeData(cloneInit);
    }
    setSubmitting(false);
  };
  const onSubmit = (data) => {
    const textError = getTextError(data);
    if (textError) {
      dispatch(
        showToast({
          message: textError,
          type: "danger",
        })
      );
      return;
    }
    const params = {
      ...data,
      isPostJob: data.isPostJob === POST_JOB.POST_JOB ? true : false,
      yearsOfExperience:
        data.yearsOfExperience === "" ? 0 : data.yearsOfExperience,
      lat,
      lng,
    };
    if (isAdd) {
      _submitCreate(params);
    } else {
      params["id"] = jobId;
      onUpdateJobInfo(params);
    }
  };

  const actionsSelectWeek = [
    {
      label: t("button.cancel"),
      onPress: () => {
        setShowModalSelectCurrentOrNextWeek(false);
        setDataUpdateShift(null);
      },
      mode: "outlined",
    },
  ];
  const actionsSelectedWeek = [
    {
      label: t("button.back"),
      onPress: () => {
        setShowConfirmSelectedNextOrCurrent(false);
      },
      mode: "outlined",
    },
    {
      label: t("button.yes"),
      onPress: () => {
        if (dataUpdateShift) {
          handleUpdateShift(dataUpdateShift, isSelectedNextWeek);
        }
      },
    },
  ];

  useEffect(() => {
    if (reload) {
      _loadData();
      setReload(false);
    }
  }, [reload]);
  useEffect(() => {
    loadClientIds();
    loadSupports();
    if (!isAdd && jobId) {
      _loadData();
      loadWorkersApplied();
    }
  }, [jobId]);

  // Chat filter options
  const chatWorkerOptions = [
    { value: "ALL", label: t("label.all") },
    ...workersApplied.map((item) => {
      const workerInfo = item.worker || {};
      const workerName = `${workerInfo.firstName || ""} ${workerInfo.lastName || ""}`.trim();
      return {
        value: item.id || workerInfo.id,
        label: workerName || `Worker ${item.id || workerInfo.id}`
      };
    })
  ];

  const chatShiftTypeOptions = [
    { value: "ALL", label: t("label.all") },
    { value: "MORNING", label: t("shift.MORNING") },
    { value: "AFTERNOON", label: t("shift.AFTERNOON") },
    { value: "EVENING", label: t("shift.EVENING") },
    { value: "NIGHT", label: t("shift.NIGHT") }
  ];

  // Fetch chat bookings when jobDetail is loaded
  useEffect(() => {
    if (jobDetail?.id && !isAdd) {
      fetchChatBookings(1, false);
    }
  }, [jobDetail?.id]);

  // Re-fetch bookings when filter changes
  useEffect(() => {
    if (jobDetail?.id && !isAdd) {
      fetchChatBookings(1, false);
    }
  }, [chatFilterWorkerId, chatFilterShiftType]);

  const fetchChatBookings = async (page = 1, append = false) => {
    setChatBookingsLoading(true);
    if (!append) {
      setChatBookingsFiltering(true);
    }
    const params = {
      job_id: jobDetail.id,
      page: page,
      size: 20,
    };
    if (chatFilterWorkerId !== "ALL") {
      params.worker_id = chatFilterWorkerId;
    }
    if (chatFilterShiftType !== "ALL") {
      params.shift_type = chatFilterShiftType;
    }
    const result = await dispatch(fetchPageBookingByJob(params));
    if (fetchPageBookingByJob.fulfilled.match(result)) {
      const payload = result.payload;
      if (append) {
        setChatBookings((prev) => [...prev, ...payload.content]);
      } else {
        setChatBookings(payload.content || []);
      }
      setChatBookingsPage(payload.pageNumber || 1);
      setChatBookingsTotalPages(payload.totalPages || 0);
    }
    setChatBookingsLoading(false);
    if (!append) {
      setChatBookingsFiltering(false);
    }
  };

  const handleChatBookingsScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (
      scrollHeight - scrollTop - clientHeight < 50 &&
      !chatBookingsLoading &&
      chatBookingsPage < chatBookingsTotalPages
    ) {
      fetchChatBookings(chatBookingsPage + 1, true);
    }
  };

  // useEffect(() => {
  //   if (!showBookingCanceledList) {
  //     setBookingCanceledList([]);
  //   }
  // }, [showBookingCanceledList]);
  // // useEffect(() => {
  //   if (!showConfirmDeleteNextWeek) {
  //     setJobAvailabilityDelete(null);
  //   }
  // }, [showConfirmDeleteNextWeek]);
  console.log('jobDetail', jobDetail);
  return (
    <React.Fragment>
      <Formik
        initialValues={initializeData}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ setFieldValue, values, handleChange, errors }) => {
          // var isAllowRemoveAvailability = true;
          // const { jobAvailabilityRequests } = values;
          // if (jobAvailabilityRequests) {
          //   for (const i in jobAvailabilityRequests) {
          //     if (jobAvailabilityRequests[i].countGroupShiftId <= 1) {
          //       isAllowRemoveAvailability = false;
          //       break
          //     }
          //   }
          //   const inactiveList = jobAvailabilityRequests.filter(item => item.status === 'INACTIVE');
          //   if (inactiveList.length >= jobAvailabilityRequests.length - 1) {
          //     isAllowRemoveAvailability = false;
          //   }
          // }

          return (
            <Form>
              {/* <Box style={{ display: 'flex', position: 'absolute', alignContent: 'center', justifyContent: 'center', width: '100%', height: '100%', alignItems: 'center' }}>
                <Box style={{ textAlign: 'center', backgroundColor: 'white'}}>
                  <Typography>The system is processing to update shift time. Please waiting to complete.</Typography>
                  <CircularProgress />
                  </Box>
                </Box> */}
              {isUpdating && (
                <Box
                  sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0,0,0,0.2)", // nhẹ cho cảm giác overlay
                    zIndex: 9999,
                  }}
                >
                  <Paper sx={{ width: "50%", textAlign: "center" }}>
                    <Box sx={{ mb: 4 }}>
                      <LinearProgress />
                    </Box>
                    <Typography variant="h5" style={{ padding: 20 }}>
                      The system is processing, please waiting to complete.
                    </Typography>
                  </Paper>
                </Box>
              )}

              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box
                    className={classNames({
                      [classes.title]: true,
                      "mt-0": true,
                    })}
                  >
                    <Typography variant="h5">
                      {t("label.participant")}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    component={SelectField}
                    name={"clientId"}
                    label={"label.participant"}
                    placeholder={"label.searchAndSelectParticipant"}
                    required
                    disabled={!isAdd}
                    options={(() => {
                      const filteredClients = isAdd
                        ? clientIds.filter((item) => item.status !== "DEACTIVATE")
                        : clientIds;
                      const options = filteredClients.map((item) => ({
                        value: item.id,
                        label: `${item.firstName} ${item.lastName} (${item.personalInfoEmail})`,
                      }));
                      if (
                        jobDetail.client &&
                        !options.find((opt) => opt.value === jobDetail.client.id)
                      ) {
                        options.push({
                          value: jobDetail.client.id,
                          label: `${jobDetail.client.firstName} ${jobDetail.client.lastName} (${jobDetail.client.personalInfoEmail})`,
                        });
                      }
                      return options;
                    })()}
                    onSelected={(selectedId) => {
                      const selectedClient = clientIds.filter(
                        (item) => item.id === selectedId
                      )[0];
                      if (selectedClient) {
                        setFieldValue("clientId", selectedClient.id);
                        setFieldValue("clientType", selectedClient.clientType);

                        setFieldValue("address1", selectedClient.address1);
                        setFieldValue(
                          "address2",
                          selectedClient.address2 || ""
                        );
                        setFieldValue("postalCode", selectedClient.postalCode);
                        setFieldValue("phone", selectedClient.phone);
                        setLatLng({
                          lat: selectedClient.lat,
                          lng: selectedClient.lng,
                        });

                        setFieldValue(
                          "billingDetail",
                          selectedClient.billingDetail
                        );
                        setFieldValue(
                          "billToAddress",
                          selectedClient.billToAddress
                        );
                        if (
                          selectedClient.billingDetail ===
                          BILLING_TYPE.PLAN_MANAGER.id
                        ) {
                          setFieldValue(
                            "planManagerOrganizationName",
                            selectedClient.planManagerOrganizationName
                          );
                          setFieldValue(
                            "planManagerPhone",
                            selectedClient.planManagerPhone
                          );
                          setFieldValue(
                            "planManagerEmail",
                            selectedClient.planManagerEmail
                          );
                        }
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                {values.billingDetail === BILLING_TYPE.PLAN_MANAGER.id && (
                  <React.Fragment>
                    <Grid item xs={12} md={6}>
                      <Field
                        component={AppInput}
                        name="planManagerOrganizationName"
                        label={"label.organizationName"}
                        disabled={true}
                      />
                      <Field
                        component={AppInput}
                        name="planManagerPhone"
                        type="tel"
                        label={"label.phoneNumber"}
                        disabled={true}
                      />
                      <Field
                        component={AppInput}
                        name="planManagerEmail"
                        label={"label.email"}
                        disabled={true}
                      />
                    </Grid>
                  </React.Fragment>
                )}
                <Grid item xs={12} md={6}>
                  <Field
                    component={SelectField}
                    label={t("label.billingDetails")}
                    placeholder={t("label.billingDetails")}
                    name={"billingDetail"}
                    options={billingDetailsOptions}
                    disabled={true}
                  />

                  {values.billingDetail === BILLING_TYPE.PLAN_MANAGER.id && (
                    <React.Fragment>
                      <Field
                        component={AppInput}
                        name="billToAddress"
                        id="billToAddress"
                        label={"label.billToAddress"}
                        disabled={true}
                      />
                    </React.Fragment>
                  )}
                </Grid>
                {values.billingDetail !== BILLING_TYPE.PLAN_MANAGER.id && (
                  <Grid item xs={12} md={6}>
                    <Field
                      component={AppInput}
                      name="billToAddress"
                      label={"label.billToAddress"}
                      disabled={true}
                    />
                  </Grid>
                )}
              </Grid>
              <Grid container spacing={2}>
                {/* Information */}
                <Grid item xs={12} md={12}>
                  <Box
                    className={classNames({
                      [classes.title]: true,
                      "mt-0": true,
                    })}
                  >
                    <Typography variant="h5">
                      {t("title.jobInformation")}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    component={AppInput}
                    name="title"
                    label={t("label.title")}
                    required
                  />
                  <Field
                    component={InputAutocompleteAddress}
                    name="address1"
                    label={"label.address1"}
                    onChangePostalCode={(postalcode) =>
                      setFieldValue("postalCode", postalcode)
                    }
                    onChangeLatLng={(latlng) => setLatLng(latlng)}
                    required
                  />
                  <Field
                    component={AppInput}
                    name="address2"
                    label={t("label.address2")}
                  />
                  <Field
                    component={AppInput}
                    name="description"
                    label={t("label.description")}
                    type="textarea"
                    required
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Field
                    component={AppInput}
                    name="postalCode"
                    type="tel"
                    mask={MASK.PHONE}
                    maskChar=""
                    label={"label.postalCode"}
                    required
                  />
                  <Field
                    component={AppInput}
                    name="phone"
                    label={t("label.phoneNumber")}
                    required
                    mask={MASK.PHONE}
                    maskChar=""
                    type="tel"
                  />
                  <Field
                    component={AppInput}
                    name="yearsOfExperience"
                    label={t("title.yearsOfExperience")}
                    type="number"
                  // disabled={workersApplied.length > 0}
                  />
                  <Field
                    component={SelectField}
                    name="supportId"
                    label={t("label.support")}
                    placeholder={t("label.support")}
                    options={supportOptions}
                    disabled={workersApplied.length > 0}
                    required
                  />
                </Grid>
                <Grid item xs={12} md={12}>
                  <Field
                    component={CustomDatePicker}
                    name="startDate"
                    label={"label.startDate"}
                    onChange={(event) => {
                      handleStartDateChange(event, values, handleChange);
                    }}
                    required
                    formatDateJob={true}
                    custom={{
                      minDate: new Date(
                        moment(new Date()).startOf("day").add(1, "days")
                      ),
                    }}
                    disabled={
                      isBooked ||
                      (!isAdd &&
                        (jobDetail.jobStatus === JOB_STATUS.ON_GOING ||
                          jobDetail.jobStatus === JOB_STATUS.DONE)) ||
                      jobDetail.client?.status === "DEACTIVATE"
                    }
                  />
                  <Field
                    component={CustomDatePicker}
                    name="endDate"
                    label={"label.endDate"}
                    onChange={(event) => {
                      handleEndDateChange(event, values, handleChange);
                    }}
                    required
                    formatDateJob={true}
                    disabled={jobType === JOB_TYPE.SINGLE_WORKER}
                    custom={{
                      minDate: getMinEndDate(values),
                    }}
                  />
                  {jobDetail.jobType === "MULTIPLE_WORKER" && (
                    <React.Fragment>
                      <RadioGroup
                        aria-label="Post Job"
                        name="isPostJob"
                        value={values.isPostJob}
                        onChange={handleChange("isPostJob")}
                        className={classes.radioGroup}
                      >
                        <FormControlLabel
                          value={POST_JOB.POST_JOB}
                          control={<AppRadio />}
                          label={t("label.postJob")}
                          className={classes.radio}
                          disabled={jobDetail.client?.status === "DEACTIVATE"}
                        />
                        <FormControlLabel
                          value={POST_JOB.UNPOST_JOB}
                          control={<AppRadio />}
                          label={t("label.unPostJob")}
                          className={classes.radio}
                          disabled={jobDetail.client?.status === "DEACTIVATE"}
                        />
                      </RadioGroup>
                      <Box className={classes.postDescription}>
                        <Box>
                          <span className={classes.bold}>
                            {t("label.postJob")}
                          </span>
                          <span>{` ${t("text.postJob")}`}</span>
                        </Box>
                        <Box>
                          <span className={classes.bold}>
                            {t("label.unPostJob")}
                          </span>
                          <span>{` ${t("text.unPostJob")}`}</span>
                        </Box>
                      </Box>
                    </React.Fragment>
                  )}
                </Grid>
                {!isAdd && (
                  <Grid item xs={12} md={12}>
                    <FormGroup className={classes.control}>
                      <AppButton
                        label={`${t("button.back")}`}
                        mode="outlined"
                        isLoading={isSubmitting}
                        disabled={isSubmitting}
                        onClick={() => history.push("/admin/jobs")}
                      />

                      <AppButton
                        className="ml-1"
                        label={`${t("button.save")}`}
                        rounder
                        type={!isAdd ? "button" : "submit"}
                        onClick={() => {
                          if (!isAdd) {
                            handleUpdateJobInfo(values);
                          }
                        }}
                        isLoading={isSubmitting || isLoading}
                        disabled={isSubmitting || isLoading}
                      />
                      {!isAdd && (
                        <AppButton
                          className="ml-1"
                          label={`${t("button.endJob")}`}
                          buttonColor={AppColor.pink}
                          type={"button"}
                          onClick={() => {
                            setShowDeleteOrEndJobModal("end_job");
                          }}
                          disabled={
                            !values.isAllowEndJob ||
                            isSubmitting ||
                            isLoading ||
                            jobDetail.client?.status === "DEACTIVATE" ||
                            moment
                              .range(
                                moment().hours(0).minutes(0).seconds(0),
                                moment(values.startDate)
                              )
                              .diff("minutes") >= 0
                          }
                          isLoading={isSubmitting || isLoading}
                        />
                      )}
                      {!isAdd && (
                        <AppButton
                          className="ml-1"
                          label={`${t("button.delete")}`}
                          buttonColor={AppColor.pink}
                          type={"button"}
                          onClick={() => {
                            setShowDeleteOrEndJobModal("delete_job");
                          }}
                          isLoading={isSubmitting || isLoading}
                          disabled={
                            !values.isAllowDelete ||
                            isSubmitting ||
                            isLoading ||
                            jobDetail.client?.status === "DEACTIVATE"
                          }
                        />
                      )}
                    </FormGroup>
                  </Grid>
                )}
                {/* Availability */}
                <Grid item xs={12} md={12} style={{ marginTop: "31px" }}>
                  <Box
                    className={classes.title}
                    id="title-job-availability-request"
                  >
                    <Typography variant="h5">
                      {t("title.availability")}
                      <span style={{ color: AppColor.red }}>*</span>
                    </Typography>
                  </Box>
                  {jobType !== JOB_TYPE.SINGLE_WORKER && (
                    <React.Fragment>
                      <JobAvailabilityFieldArray
                        jobId={jobId}
                        setFieldValue={setFieldValue}
                        handleChange={handleChange}
                        // isAllowRemoveAvailability={isAllowRemoveAvailability}
                        formData={values}
                        errors={errors}
                        // setJobAvailabilityDelete={setJobAvailabilityDelete}
                        // setShowConfirmDeleteNextWeek={setShowConfirmDeleteNextWeek}
                        getNumberDayOfWeek={getNumberDayOfWeek}
                        isLoading={isLoading}
                        isSubmitting={isSubmitting}
                        handleCreateUpdateShift={handleCreateUpdateShift}
                        handleShowPopupDeleteShift={handleShowPopupDeleteShift}
                        handleChangeDayOfWeek={handleChangeDayOfWeek}
                        initializeData={initializeData}
                        isAdd={isAdd}
                        isDisabled={jobDetail.client?.status === "DEACTIVATE"}
                      />
                    </React.Fragment>
                  )}
                </Grid>
              </Grid>
              {/* Button */}
              {isAdd && (
                <FormGroup
                  className={`${classes.control} ${classes.buttonCreate}`}
                >
                  <AppButton
                    className="mb-3"
                    label={`${t("button.back")}`}
                    mode="outlined"
                    isLoading={isSubmitting}
                    disabled={isSubmitting}
                    onClick={() => history.push("/admin/jobs")}
                  />
                  <AppButton
                    className="ml-1 mb-3"
                    label={`${t("button.save")}`}
                    rounder
                    type={"submit"}
                    isLoading={isSubmitting || isLoading}
                    disabled={isSubmitting || isLoading}
                  />
                </FormGroup>
              )}
              {
                // !isAdd && isBooked && bookingCanceledList.length > 0 &&
                // <AppDialog
                //   open={showBookingCanceledList}
                //   onClose={() => {
                //     setShowBookingCanceledList(false);
                //     setDataUpdateShift(null);
                //   }}
                //   maxWidth="md"
                //   title={t('title.update_job')}
                // >
                //   <TableBookingWillCancel
                //     classes={classes}
                //     isLoading={isLoading}
                //     isSubmitting={isSubmitting}
                //     setShowBookingCanceledList={setShowBookingCanceledList}
                //     bookingCanceledList={bookingCanceledList}
                //     handleSubmit={() => handleUpdateShift(dataUpdateShift, isApplyNextWeekForShift)}
                //     setDataUpdateShift={setDataUpdateShift}
                //   />
                //   {/* {renderTableBookingWillCancel(values, handleSubmit)} */}
                // </AppDialog>
              }
              <AppConfirmDialog
                open={dataUpdateShift !== null && showConfirmDeleteNextWeek}
                onConfirm={() => {
                  setShowConfirmDeleteNextWeek(false);
                  // setFieldValue(jobAvailabilityDelete, true);
                  handleUpdateShift(dataUpdateShift);
                }}
                onClose={() => {
                  setDataUpdateShift(null);
                  setShowConfirmDeleteNextWeek(false);
                }}
                cancelLabel={t("button.no")}
                isDisabledButton={isLoading || isSubmitting}
                title={t("title.deleteJobAvailabilityNextWeek")}
                content={t("text.deleteJobAvailabilityNextWeek")}
              />
            </Form>
          );
        }}
      </Formik>
      <Box
        className="mb-3 mt-3"
        style={{ display: isMobile ? "flex" : "block" }}
      >
        {!isAdd && jobType === JOB_TYPE.MULTIPLE_WORKER && (
          <React.Fragment>
            <AppButton
              className="mr-1"
              label={t(
                `${isMobile ? "title.searchWorker" : "label.searchSupportWorker"
                }`
              )}
              rounder
              onClick={() => setShowSearchWorker(true)}
              isLoading={isLoading}
              disabled={
                isLoading || jobDetail.client?.status === "DEACTIVATE"
              }
            />
            <AppButton
              className="mr-1"
              label={`${t("label.booking")}`}
              rounder
              buttonColor={AppColor.pink}
              onClick={() => setShowBookingWorker(true)}
              isLoading={isLoading}
              disabled={
                isLoading || jobDetail.client?.status === "DEACTIVATE"
              }
            />
            <AppButton
              className="mr-1"
              label={`${t("label.autoBooking")}`}
              rounder
              buttonColor={AppColor.mainColor}
              onClick={() => setIsOpenModalAutoBooking(true)}
              isLoading={isLoading}
              disabled={
                isLoading || jobDetail.client?.status === "DEACTIVATE"
              }
            />
          </React.Fragment>
        )}
        {/* {!isAdd && (
          <img
            onClick={() => setShowCalendar(true)}
            src={CalendarIcon}
            className={classes.calendar}
          />
        )} */}
      </Box>
      <Grid container spacing={3} style={{ marginBottom: "2rem" }}>
        {workersApplied.map((item, index) => (
          <Grid item xs={12} sm={12} md={6} key={`appiled-worker-${index}`}>
            <JobUserTag
              isApplied
              userInfo={item.worker}
              onRemove={handleRemoveWorker}
              setReload={setReload}
              isBooked={item.applyStatus === BOOKING_STATUS.BOOKED}
              isDisable={jobDetail.client?.status === "DEACTIVATE"}
            />
          </Grid>
        ))}
      </Grid>
      <AppDialog
        open={showSearchWorker}
        onClose={() => {
          setShowSearchWorker(false);
          _loadData();
        }}
        maxWidth="sm"
        title={t("label.searchSupportWorker")}
      >
        <SearchWorkerModal
          jobId={jobId}
          loadWorkersApplied={loadWorkersApplied}
        />
      </AppDialog>
      <AppDialog
        open={showBookingWorker}
        onClose={() => {
          _loadData();
          loadWorkersApplied();
          setShowBookingWorker(false);
          setSelectedWeek({});
        }}
        maxWidth="md"
        title={t("label.booking")}
      >
        {showBookingWorker && (
          <BookingWorkerModal
            jobId={jobId}
            loadJob={_loadData}
            jobDetail={initializeData}
            jobAvailabilities={jobAvailabilityList}
            onAddShift={onAddShift}
            selectedWeek={selectedWeek}
            setSelectedWeek={setSelectedWeek}
            setReload={setReload}
          />
        )}
      </AppDialog>
      <AppConfirmDialog
        open={!!showDeleteOrEndJobModal}
        onConfirm={() => _handleDeleteOrEndJob()}
        onClose={() => setShowDeleteOrEndJobModal(null)}
        isDisabledButton={isLoading || isSubmitting}
        title={t(
          `title.${showDeleteOrEndJobModal ? showDeleteOrEndJobModal : "end_job"
          }`
        )}
        content={t(
          `text.${showDeleteOrEndJobModal === "delete_job"
            ? "messageDeleteThisJob"
            : "messageEndThisJob"
          }`
        )}
      />
      {/* auto booking */}
      <AppConfirmDialog
        open={!!isOpenModalAutoBooking}
        onConfirm={() => handleAutoBooking()}
        onClose={() => setIsOpenModalAutoBooking(false)}
        isDisabledButton={isLoading || isSubmitting}
        title={t(`title.autoBooking`)}
        content={t(`text.confirmAutoBooking`)}
      />
      {/* delete shift */}
      <AppConfirmDialog
        open={idsDeleteAvailability.length > 0}
        onConfirm={() => handleDeleteShift()}
        onClose={() => {
          setIdsDeleteAvailability([]);
          setMessageDeleteAvailabilityModal(null);
        }}
        isDisabledButton={isLoading || isSubmitting}
        title={getTitleMessageDeleteShift(messageDeleteAvailabilityModal)}
        content={getMessageDeleteShift(messageDeleteAvailabilityModal)}
      />
      {/* delete day of week */}
      <AppConfirmDialog
        open={paramsDeleteDayOfWeek !== null}
        onConfirm={() => handleDeleteDayOfWeek()}
        onClose={() => {
          setParamsDeleteDayOfWeek(null);
          setMessageDeleteAvailabilityModal(null);
        }}
        isDisabledButton={isLoading || isSubmitting}
        title={getTitleMessageDeleteShift(messageDeleteAvailabilityModal)}
        content={getMessageDeleteShift(messageDeleteAvailabilityModal)}
      />
      {/* Update shift has deleted is booked */}
      <AppConfirmDialog
        open={
          dataUpdateShift !== null &&
          (messageDeleteAvailabilityModal ===
            enumConfirmDialog.deleteDayOfWeekListHasBooked ||
            messageDeleteAvailabilityModal ===
            enumConfirmDialog.changeSettingBooking)
        }
        onConfirm={() => {
          if (dataUpdateShift) {
            setMessageDeleteAvailabilityModal(null);
            if (!showModalSelectCurrentOrNextWeek) {
              handleUpdateShift(dataUpdateShift, false);
            }
          }
        }}
        onClose={() => {
          setMessageDeleteAvailabilityModal(null);
          setDataUpdateShift(null);
          setShowModalSelectCurrentOrNextWeek(false);
        }}
        isDisabledButton={isLoading || isSubmitting}
        title={getTitleMessageDeleteShift(messageDeleteAvailabilityModal)}
        content={getMessageDeleteShift(messageDeleteAvailabilityModal)}
      />
      <AppDialog
        open={
          dataUpdateShift !== null &&
          showModalSelectCurrentOrNextWeek &&
          messageDeleteAvailabilityModal === null
        }
        actions={
          showConfirmSelectedNextOrCurrent
            ? actionsSelectedWeek
            : actionsSelectWeek
        }
        title={t("title.confirmApplyNextWeek")}
        onClose={() => {
          setShowModalSelectCurrentOrNextWeek(false);
          setDataUpdateShift(null);
          setShowConfirmSelectedNextOrCurrent(false);
          setIsSelectedNextWeek(false);
        }}
      >
        <div>
          {showConfirmSelectedNextOrCurrent ? (
            <Box mb={2} mt={2}>
              <p className={classes.listTitle}>
                {isSelectedNextWeek
                  ? t("text.settingApplyNextWeek")
                  : t("text.settingApplyCurrentWeek")}
              </p>
            </Box>
          ) : (
            <List>
              <ListItem
                className={classes.listItem}
                button
                onClick={() => {
                  if (!isLoading && !isSubmitting && dataUpdateShift !== null) {
                    setShowConfirmSelectedNextOrCurrent(true);
                    setIsSelectedNextWeek(false);
                    // handleUpdateShift(dataUpdateShift, false);
                  }
                }}
              >
                <ListItemText
                  primary={
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignContent="center"
                    >
                      {t("button.currentWeek")}
                      <ChevronRight />
                    </Box>
                  }
                />
              </ListItem>
              <ListItem
                className={classes.listItem}
                button
                onClick={() => {
                  if (!isLoading && !isSubmitting && dataUpdateShift !== null) {
                    setShowConfirmSelectedNextOrCurrent(true);
                    setIsSelectedNextWeek(true);
                    // handleUpdateShift(dataUpdateShift, true);
                  }
                }}
              >
                <ListItemText
                  primary={
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      alignContent="center"
                    >
                      {t("button.nextWeek")}
                      <ChevronRight />
                    </Box>
                  }
                />
              </ListItem>
            </List>
          )}
        </div>
      </AppDialog>
      {/* <AppDialog
        open={showCalendar}
        onClose={() => setShowCalendar(false)}
        maxWidth="lg"
        title={t("label.calendar")}
      >
              <AppDialog
        open={showCalendar}
        onClose={() => setShowCalendar(false)}
        maxWidth="lg"
        title={t("label.calendar")}
      >
        <WorkerCalendarModal jobId={jobId} jobDetail={jobDetail} setShowBookingWorker={setShowBookingWorker} workersApplied={workersApplied} reloadJob={() => {_loadData(); loadWorkersApplied();}} />
      </AppDialog>

      </AppDialog> */}
      {/* show confirm Update Shift for next or current week */}
      {/* <AppConfirmDialog
        open={dataUpdateShift !== null && showConfirmSelectedNextOrCurrent}
        onConfirm={() => {
          if (dataUpdateShift) {
            handleUpdateShift(dataUpdateShift, isSelectedNextWeek);
          }
        }}
        onClose={() => {
          setShowConfirmSelectedNextOrCurrent(false);
        }}
        isDisabledButton={isLoading || isSubmitting}
        title={t('title.confirmUpdate')}
        content={isSelectedNextWeek ? t('text.settingApplyNextWeek') : t('text.settingApplyCurrentWeek')}
      /> */}
      {!isAdd && jobDetail && (
        <Box>
          <Typography style={{ color: "#3D2C3E 50%", fontStyle: "normal", fontWeight: "700", fontSize: "16px", lineHeight: "19px", marginBottom: "10px" }}>
            {t("label.chat")}
          </Typography>
          <Grid container spacing={0} style={{ marginTop: "1rem", border: "1px solid #e0e0e0", borderRadius: "8px", overflow: "hidden", minHeight: "700px" }}>
            {/* Left Panel: Filter + Bookings List */}
            <Grid item xs={12} md={4} style={{ borderRight: "1px solid #e0e0e0", backgroundColor: "#f9f9f9", display: "flex", flexDirection: "column", maxHeight: "700px" }}>
              {/* Worker Filter */}
              <Box p={2} style={{ borderBottom: "1px solid #e0e0e0" }}>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px" }}>
                  {t("label.worker")}
                </Typography>
                <AppSelect
                  name="worker"
                  placeholder={t("label.worker")}
                  isNotMargin
                  isNotClearable={true}
                  value={chatWorkerOptions.find(opt => opt.value === chatFilterWorkerId)}
                  onChange={(option) => {
                    setChatFilterWorkerId(option ? option.value : "ALL");
                  }}
                  options={chatWorkerOptions}
                />
              </Box>

              {/* Shift Type Filter */}
              <Box p={2} style={{ borderBottom: "1px solid #e0e0e0" }}>
                <Typography variant="subtitle2" style={{ fontWeight: 600, marginBottom: "8px" }}>
                  {t("label.shiftType")}
                </Typography>
                <AppSelect
                  name="shiftType"
                  placeholder={t("label.shiftType")}
                  isNotMargin
                  isNotClearable={true}
                  value={chatShiftTypeOptions.find(opt => opt.value === chatFilterShiftType)}
                  onChange={(option) => {
                    setChatFilterShiftType(option ? option.value : "ALL");
                  }}
                  options={chatShiftTypeOptions}
                />
              </Box>

              {/* Bookings List */}
              <Box style={{ flex: 1, overflowY: "auto", position: "relative" }} onScroll={handleChatBookingsScroll}>
                {/* Loading Overlay */}
                {chatBookingsFiltering && (
                  <Box
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.7)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 10,
                      backdropFilter: "blur(2px)",
                    }}
                  >
                    <CircularProgress size={40} />
                  </Box>
                )}

                {(() => {
                  return (
                    <>
                      {chatBookings.map((booking, index) => {
                        const shiftName = booking.shiftType ? t(`shift.${booking.shiftType}`) : "Unknown Shift";
                        const dateStr = booking.bookingDate ? moment(booking.bookingDate).format("DD/MM/YYYY") : "";
                        const startTimeStr = booking.startTime ? moment(booking.startTime).format("HH:mm") : "";
                        const endTimeStr = booking.endTime ? moment(booking.endTime).format("HH:mm") : "";
                        const timeStr = startTimeStr && endTimeStr ? `${startTimeStr} - ${endTimeStr}` : "";
                        const isSelected = chatSelectedBookingId === booking.bookingId;

                        return (
                          <Box
                            key={`booking-item-${booking.bookingId}`}
                            onClick={() => setChatSelectedBookingId(booking.bookingId)}
                            style={{
                              padding: "12px 16px",
                              borderBottom: "1px solid #e0e0e0",
                              cursor: "pointer",
                              backgroundColor: isSelected ? "#e3f2fd" : (index % 2 === 0 ? "#fff" : "#fafafa"),
                              borderLeft: isSelected ? "3px solid #1976d2" : "3px solid transparent",
                              transition: "background-color 0.2s",
                            }}
                          >
                            <Typography variant="body2" style={{ fontWeight: isSelected ? 600 : 400, color: isSelected ? "#1976d2" : "#333" }}>
                              {shiftName}
                            </Typography>
                            <Typography variant="caption" style={{ color: "#666", display: "block" }}>
                              {dateStr} {timeStr}
                            </Typography>
                            {booking.workerName && (
                              <Typography variant="caption" style={{ color: "#999", display: "block", fontSize: "11px", fontWeight: 800 }}>
                                {booking.workerName}
                              </Typography>
                            )}
                          </Box>
                        );
                      })}

                      {chatBookingsLoading && !chatBookingsFiltering && (
                        <Box p={2} textAlign="center">
                          <LinearProgress />
                        </Box>
                      )}

                      {chatBookings.length === 0 && !chatBookingsLoading && (
                        <Box p={3} textAlign="center">
                          <Typography variant="body2" style={{ color: "#999" }}>
                            {t("label.no_data")}
                          </Typography>
                        </Box>
                      )}
                    </>
                  );
                })()}
              </Box>
            </Grid>

            {/* Right Panel: Chat Content */}
            <Grid item xs={12} md={8} style={{ display: "flex", flexDirection: "column", maxHeight: "700px", overflowY: "auto" }}>
              {chatSelectedBookingId ? (
                (() => {
                  const selectedBooking = chatBookings.find((b) => b.bookingId === chatSelectedBookingId);
                  if (!selectedBooking) return null;
                  const shiftName = selectedBooking.shiftType ? t(`shift.${selectedBooking.shiftType}`) : "Unknown Shift";
                  const dateStr = selectedBooking.bookingDate ? moment(selectedBooking.bookingDate).format("DD/MM/YYYY") : "";
                  const startTimeStr = selectedBooking.startTime ? moment(selectedBooking.startTime).format("HH:mm") : "";
                  const endTimeStr = selectedBooking.endTime ? moment(selectedBooking.endTime).format("HH:mm") : "";
                  const timeStr = startTimeStr && endTimeStr ? `${startTimeStr} - ${endTimeStr}` : "";

                  return (
                    <ChatContents
                      jobId={jobId}
                      jobStatus={jobDetail.jobStatus}
                      bookingId={chatSelectedBookingId}
                      title={`${shiftName} ${dateStr} ${timeStr}`}
                      shiftType={selectedBooking.shiftType}
                      isDisable={jobDetail.client?.status === "DEACTIVATE"}
                      fetchDataSuccess={(hasData) => setIsShowChat((value) => value || hasData)}
                    />
                  );
                })()
              ) : (
                <Box display="flex" alignItems="center" justifyContent="center" style={{ flex: 1, minHeight: "300px" }}>
                  <Typography variant="body1" style={{ color: "#999" }}>
                    {t("text.selectBookingToViewChat")}
                  </Typography>
                </Box>
              )}
            </Grid>
          </Grid>
        </Box>
      )}
    </React.Fragment>
  );
};

JobDetail.propTypes = {
  isAdd: PropTypes.bool,
  isAdmin: PropTypes.bool,
  jobId: PropTypes.any,
  onCancel: PropTypes.func,
  clientDetail: PropTypes.object,
};

export default JobDetail;
